(function (lib, img, cjs, ss, an) {

var p; // shortcut to reference prototypes
lib.ssMetadata = [
		{name:"MWlion_atlas_", frames: [[1896,1624,126,298],[910,1584,126,298],[1038,1654,126,298],[1896,1324,126,298],[262,1580,162,346],[426,1580,162,346],[1732,1324,162,346],[1884,976,162,346],[1374,330,278,320],[280,610,278,320],[1654,330,278,320],[0,294,278,320],[1094,286,278,324],[840,612,274,322],[1392,652,274,322],[0,616,274,322],[1116,652,274,322],[546,932,268,322],[276,932,268,322],[816,936,268,322],[1668,652,268,322],[528,1256,260,322],[0,1268,260,322],[266,1256,260,322],[790,1260,260,322],[1352,976,264,326],[1618,976,264,326],[1086,976,264,326],[0,940,264,326],[560,610,278,320],[810,286,282,322],[520,286,288,322],[1556,0,290,328],[750,1584,158,312],[1848,0,158,312],[280,294,158,312],[590,1580,158,312],[1052,1304,168,348],[1222,1304,168,348],[1392,1304,168,348],[1562,1304,168,348],[1166,1654,126,292],[520,0,516,284],[1038,0,516,284],[0,0,518,292],[0,1592,208,208],[1294,1654,176,176]]}
];


// symbols:



(lib.LionFrontLegBack0001 = function() {
	this.spriteSheet = ss["MWlion_atlas_"];
	this.gotoAndStop(0);
}).prototype = p = new cjs.Sprite();



(lib.LionFrontLegBack0002 = function() {
	this.spriteSheet = ss["MWlion_atlas_"];
	this.gotoAndStop(1);
}).prototype = p = new cjs.Sprite();



(lib.LionFrontLegBack0003 = function() {
	this.spriteSheet = ss["MWlion_atlas_"];
	this.gotoAndStop(2);
}).prototype = p = new cjs.Sprite();



(lib.LionFrontLegBack0004 = function() {
	this.spriteSheet = ss["MWlion_atlas_"];
	this.gotoAndStop(3);
}).prototype = p = new cjs.Sprite();



(lib.LionFrontLeg0001 = function() {
	this.spriteSheet = ss["MWlion_atlas_"];
	this.gotoAndStop(4);
}).prototype = p = new cjs.Sprite();



(lib.LionFrontLeg0002 = function() {
	this.spriteSheet = ss["MWlion_atlas_"];
	this.gotoAndStop(5);
}).prototype = p = new cjs.Sprite();



(lib.LionFrontLeg0003 = function() {
	this.spriteSheet = ss["MWlion_atlas_"];
	this.gotoAndStop(6);
}).prototype = p = new cjs.Sprite();



(lib.LionFrontLeg0004 = function() {
	this.spriteSheet = ss["MWlion_atlas_"];
	this.gotoAndStop(7);
}).prototype = p = new cjs.Sprite();



(lib.LionHead_0010001 = function() {
	this.spriteSheet = ss["MWlion_atlas_"];
	this.gotoAndStop(8);
}).prototype = p = new cjs.Sprite();



(lib.LionHead_0010002 = function() {
	this.spriteSheet = ss["MWlion_atlas_"];
	this.gotoAndStop(9);
}).prototype = p = new cjs.Sprite();



(lib.LionHead_0010003 = function() {
	this.spriteSheet = ss["MWlion_atlas_"];
	this.gotoAndStop(10);
}).prototype = p = new cjs.Sprite();



(lib.LionHead_0010004 = function() {
	this.spriteSheet = ss["MWlion_atlas_"];
	this.gotoAndStop(11);
}).prototype = p = new cjs.Sprite();



(lib.LionHead_001_wet0004 = function() {
	this.spriteSheet = ss["MWlion_atlas_"];
	this.gotoAndStop(12);
}).prototype = p = new cjs.Sprite();



(lib.LionHead_0020001 = function() {
	this.spriteSheet = ss["MWlion_atlas_"];
	this.gotoAndStop(13);
}).prototype = p = new cjs.Sprite();



(lib.LionHead_0020002 = function() {
	this.spriteSheet = ss["MWlion_atlas_"];
	this.gotoAndStop(14);
}).prototype = p = new cjs.Sprite();



(lib.LionHead_0020003 = function() {
	this.spriteSheet = ss["MWlion_atlas_"];
	this.gotoAndStop(15);
}).prototype = p = new cjs.Sprite();



(lib.LionHead_0020004 = function() {
	this.spriteSheet = ss["MWlion_atlas_"];
	this.gotoAndStop(16);
}).prototype = p = new cjs.Sprite();



(lib.LionHead_0030001 = function() {
	this.spriteSheet = ss["MWlion_atlas_"];
	this.gotoAndStop(17);
}).prototype = p = new cjs.Sprite();



(lib.LionHead_0030002 = function() {
	this.spriteSheet = ss["MWlion_atlas_"];
	this.gotoAndStop(18);
}).prototype = p = new cjs.Sprite();



(lib.LionHead_0030003 = function() {
	this.spriteSheet = ss["MWlion_atlas_"];
	this.gotoAndStop(19);
}).prototype = p = new cjs.Sprite();



(lib.LionHead_0030004 = function() {
	this.spriteSheet = ss["MWlion_atlas_"];
	this.gotoAndStop(20);
}).prototype = p = new cjs.Sprite();



(lib.LionHead_0040001 = function() {
	this.spriteSheet = ss["MWlion_atlas_"];
	this.gotoAndStop(21);
}).prototype = p = new cjs.Sprite();



(lib.LionHead_0040002 = function() {
	this.spriteSheet = ss["MWlion_atlas_"];
	this.gotoAndStop(22);
}).prototype = p = new cjs.Sprite();



(lib.LionHead_0040003 = function() {
	this.spriteSheet = ss["MWlion_atlas_"];
	this.gotoAndStop(23);
}).prototype = p = new cjs.Sprite();



(lib.LionHead_0040004 = function() {
	this.spriteSheet = ss["MWlion_atlas_"];
	this.gotoAndStop(24);
}).prototype = p = new cjs.Sprite();



(lib.LionHead_0050001 = function() {
	this.spriteSheet = ss["MWlion_atlas_"];
	this.gotoAndStop(25);
}).prototype = p = new cjs.Sprite();



(lib.LionHead_0050002 = function() {
	this.spriteSheet = ss["MWlion_atlas_"];
	this.gotoAndStop(26);
}).prototype = p = new cjs.Sprite();



(lib.LionHead_0050003 = function() {
	this.spriteSheet = ss["MWlion_atlas_"];
	this.gotoAndStop(27);
}).prototype = p = new cjs.Sprite();



(lib.LionHead_0050004 = function() {
	this.spriteSheet = ss["MWlion_atlas_"];
	this.gotoAndStop(28);
}).prototype = p = new cjs.Sprite();



(lib.LionHead_roar_0020004 = function() {
	this.spriteSheet = ss["MWlion_atlas_"];
	this.gotoAndStop(29);
}).prototype = p = new cjs.Sprite();



(lib.LionHead_roar_0030004 = function() {
	this.spriteSheet = ss["MWlion_atlas_"];
	this.gotoAndStop(30);
}).prototype = p = new cjs.Sprite();



(lib.LionHead_roar_0040004 = function() {
	this.spriteSheet = ss["MWlion_atlas_"];
	this.gotoAndStop(31);
}).prototype = p = new cjs.Sprite();



(lib.LionHead_roar_0050004 = function() {
	this.spriteSheet = ss["MWlion_atlas_"];
	this.gotoAndStop(32);
}).prototype = p = new cjs.Sprite();



(lib.LionHindLegBack0001 = function() {
	this.spriteSheet = ss["MWlion_atlas_"];
	this.gotoAndStop(33);
}).prototype = p = new cjs.Sprite();



(lib.LionHindLegBack0002 = function() {
	this.spriteSheet = ss["MWlion_atlas_"];
	this.gotoAndStop(34);
}).prototype = p = new cjs.Sprite();



(lib.LionHindLegBack0003 = function() {
	this.spriteSheet = ss["MWlion_atlas_"];
	this.gotoAndStop(35);
}).prototype = p = new cjs.Sprite();



(lib.LionHindLegBack0004 = function() {
	this.spriteSheet = ss["MWlion_atlas_"];
	this.gotoAndStop(36);
}).prototype = p = new cjs.Sprite();



(lib.LionHindLeg0001 = function() {
	this.spriteSheet = ss["MWlion_atlas_"];
	this.gotoAndStop(37);
}).prototype = p = new cjs.Sprite();



(lib.LionHindLeg0002 = function() {
	this.spriteSheet = ss["MWlion_atlas_"];
	this.gotoAndStop(38);
}).prototype = p = new cjs.Sprite();



(lib.LionHindLeg0003 = function() {
	this.spriteSheet = ss["MWlion_atlas_"];
	this.gotoAndStop(39);
}).prototype = p = new cjs.Sprite();



(lib.LionHindLeg0004 = function() {
	this.spriteSheet = ss["MWlion_atlas_"];
	this.gotoAndStop(40);
}).prototype = p = new cjs.Sprite();



(lib.LionTail = function() {
	this.spriteSheet = ss["MWlion_atlas_"];
	this.gotoAndStop(41);
}).prototype = p = new cjs.Sprite();



(lib.LionTorso0001 = function() {
	this.spriteSheet = ss["MWlion_atlas_"];
	this.gotoAndStop(42);
}).prototype = p = new cjs.Sprite();



(lib.LionTorso0002 = function() {
	this.spriteSheet = ss["MWlion_atlas_"];
	this.gotoAndStop(43);
}).prototype = p = new cjs.Sprite();



(lib.LionTorso_wet0002 = function() {
	this.spriteSheet = ss["MWlion_atlas_"];
	this.gotoAndStop(44);
}).prototype = p = new cjs.Sprite();



(lib.M_Wash_Bubble = function() {
	this.spriteSheet = ss["MWlion_atlas_"];
	this.gotoAndStop(45);
}).prototype = p = new cjs.Sprite();



(lib.M_Wash_Bubble_pop = function() {
	this.spriteSheet = ss["MWlion_atlas_"];
	this.gotoAndStop(46);
}).prototype = p = new cjs.Sprite();
// helper functions:

function mc_symbol_clone() {
	var clone = this._cloneProps(new this.constructor(this.mode, this.startPosition, this.loop));
	clone.gotoAndStop(this.currentFrame);
	clone.paused = this.paused;
	clone.framerate = this.framerate;
	return clone;
}

function getMCSymbolPrototype(symbol, nominalBounds, frameBounds) {
	var prototype = cjs.extend(symbol, cjs.MovieClip);
	prototype.clone = mc_symbol_clone;
	prototype.nominalBounds = nominalBounds;
	prototype.frameBounds = frameBounds;
	return prototype;
	}


(lib.Wet_drop = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#91D6F7").s().p("AgeBSQgPgSgCgjQgCgiAkheQA2BhAFAgQAFAkgOARQgOARgUAAQgTAAgOgSg");
	this.shape.setTransform(4.8,10);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,9.6,20);


(lib.SmallStar = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFF99").s().p("Ag1BSQgGgDAFgaIAHgaIgVgVQgVgUADgFQACgFAbgFIAbgFIAMgYQAOgYAEAAQAHAAAYAyIAbADQAbAEACAGQAEAJgtAlQAPAzgHAEQgHAEgvgaQgkAXgNAAIgEgBg");

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-8.7,-8.3,17.6,16.7);


(lib.LargeStar = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFF99").s().p("AhGBuQgJgFAHgjIAJgiIgcgbQgbgcADgGQADgHAkgHIAjgGIARggQATghAFABQAKgBAgBDIAjAEQAkAGADAIQAFAMg7AxQAUBEgKAGQgKAFg+gjQgwAegRAAIgFAAg");

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-11.6,-11,23.4,22.1);


(lib.sparkle = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFFFF").s().p("AgZAGQAYgRABg2QACA2AYANQgWAVgDArQgIgxgSgLg");
	this.shape.setTransform(-0.1,1);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#FFFFFF").s().p("AggAkQgLgQgMgHQANgKAKgOQAdgsADhXQAEBYAeAoQAJAMAMAHIABAAQgNALgJAQQgaApgFBFIAAABQgNhJgWgig");
	this.shape_1.setTransform(-0.1,1);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("#FFFFFF").s().p("AgyA5QgQgZgTgMQAUgPAPgWQAthEAFiHQAGCJAvA9QAOAUASAKQgSASgOAYQgpBAgHBrQgVhwgig0gAgZAGQASALAIAxQAEgsAVgUQgYgNgCg3QgBA3gYARg");
	this.shape_2.setTransform(-0.1,1);

	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.f("#FFFFFF").s().p("Ag0BYQA1AmAzgmQgnBAgHBqQgWh2gkg0gAhxAKQATgNAPgYQgVAlAVAlQgQgZgSgMgABRgfQAOATATALQgTARgOAYQAUglgUgigAgrhAQAnhDAEh9QAHCDAqA9QgugpguApg");
	this.shape_3.setTransform(-0.2,2);

	this.shape_4 = new cjs.Shape();
	this.shape_4.graphics.f("#FFFFFF").s().p("AgMC8QAQAaAOgaQgIAlgEAtQgHgugLgkgAh7ALIASgPQgMARALAMQgIgJgJgFgABvgJIANAJIgNAMQAIgMgIgJgAgJisQAIgrABg2QADA3AJAqQgLgOgKAOg");
	this.shape_4.setTransform(-0.3,1.9);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape}]}).to({state:[{t:this.shape_1}]},1).to({state:[{t:this.shape_2}]},1).to({state:[{t:this.shape_3}]},1).to({state:[{t:this.shape_4}]},1).to({state:[]},1).wait(45));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-2.7,-5.7,5.2,13.3);


(lib.mouthmudbottom = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{mud:0,soap:34,clean:46});

	// timeline functions:
	this.frame_0 = function() {
		/* stop();*/
	}
	this.frame_34 = function() {
		/* stop();*/
	}
	this.frame_46 = function() {
		/* stop();*/
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(34).call(this.frame_34).wait(12).call(this.frame_46).wait(12));

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(169,114,78,0.8)").s().p("AAYBCIgMgQIgQgEQgQgEgNgJQgMgJgHgCIgYgIQgQgFgagOQgZgOgNgMQgMgKgGgSIADgCQARADAOAGIAAABIAZADQASAPAbAGIACAAQgBABABAAQAAABAAAAQAAAAABAAQAAAAABAAQABAAAAAAQAAAAABAAQAAABABAAQAAABAAABIAKACIABABIACACIBTAFIA0gEIABgBIACgBQAEAAAEgCIAGgDIAFgGQACgCAFABIALgKIAGgGIABgDQABAAAAAAQABAAAAAAQAAAAABAAQAAAAABgBIACgDIAEgCIAFABIAEgDQAEgJAFgEIAFgCIABgCIALgBQAAAjgOAeQgSAjgeAAQgeAAgEAEQgBALgFANQgFAXgUAAQgUAAgGgKgAiwhBIAAgBIACAAIAAAAIABACg");
	this.shape.setTransform(21.5,16.4);

	this.timeline.addTween(cjs.Tween.get(this.shape).to({_off:true},22).wait(36));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(3.9,8.8,35.4,15.3);


(lib.M_Wash_Bubble_pop_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.M_Wash_Bubble_pop();
	this.instance.parent = this;
	this.instance.setTransform(-9,-9,0.25,0.25);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#FFFFFF").ss(1.9,1,1).p("AAtACIARAAAACg9IAAAUAAgghIAJgMAg9AAIAYgBAgmgrIANAPAgrArIALgNAgEAwIAAAOAAdAoIAKAN");
	this.shape.setTransform(11.2,10.6);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.M_Wash_Bubble_pop_1, new cjs.Rectangle(-9,-9,44,44), null);


(lib.M_Wash_Bubble_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.M_Wash_Bubble();
	this.instance.parent = this;
	this.instance.setTransform(-13,-13,0.25,0.25);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.M_Wash_Bubble_1, new cjs.Rectangle(-13,-13,52,52), null);


(lib.LionHead_roar_005 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Eyelid
	this.instance = new lib.LionHead_roar_0050004();
	this.instance.parent = this;
	this.instance.setTransform(-39,-7.9,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(210));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-60,-18.8,166,178.1);


(lib.LionHead_roar_004 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 4
	this.instance = new lib.LionHead_roar_0040004();
	this.instance.parent = this;
	this.instance.setTransform(-35.9,-7.4,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(210));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-56.5,-22.2,164.6,177.5);


(lib.LionHead_roar_003 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Eyelid
	this.instance = new lib.LionHead_roar_0030004();
	this.instance.parent = this;
	this.instance.setTransform(-36.4,-7.9,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(210));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-43.2,-15.9,147.8,169);


(lib.LionHead_roar_002 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Eyelid
	this.instance = new lib.LionHead_roar_0020004();
	this.instance.parent = this;
	this.instance.setTransform(-35,-7.5,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(210));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-42.2,-15.9,148,168.4);


(lib.lion_pawMud_004 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{dirty:0,dirty_loop:1,"clean":2,clean_loop:3,glow:4,glow_loop:5,wash:6,wash_stop:260,"final":262,final_loop:263});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(169,114,78,0.8)").s().p("AgXBiIgDgGIgLgJIgJgBIgRgLQgGgMgQgKQgDAAADgHIgOgRIgIgGIAAgBIAEgLIAFgOQgCgKABgIQACgQAQAAIAHABIgEgTQgEgMAAgJQADgLAGgMQALgXAPAAQAPAAALAQIAAABIABAAQAFAJAFAMIAAABQgBADABAEQABAFADAEIAAAWIAFAFQADAFAAAEQAbAIAfgEQABAEAAAFIAEAdQAAAJAEANQAQgCANAOQAJALgBAKQABALABAJIAAABIgCAjQAAAFgDACQgDABgIgDIgFAEQg7gMgzgRg");
	this.shape.setTransform(17.3,29.2);

	this.timeline.addTween(cjs.Tween.get(this.shape).to({_off:true},2).wait(2).to({_off:false},0).to({_off:true},2).wait(296));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(6.5,16.5,21.7,25.4);


(lib.lion_maneGlow = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#FFFF00").ss(6,1,1).p("AFzntIANABQACAAABAAQABgBAAgDQAAgSgYgWQgogkgzgXQgHgDgGgCQgDgBgDgCQgMgFgMgBQgtgLgoAKQABgDACgDQANgVABABQgEgag0AVQgDAAgDACQgtATgDgEQgUghgVgGQg3AegNgJQgQgKgVgDQgYgBgLgCIgBAIQABAHAHAOQgbAAgbAKQgIABgMABQgBAEgNAKQgVALgYASQgVAPglAcQAAADAAABQABABADAAQABAAABAAQgDAEAAAGQAAACABABQgHAGgIAGQg3AtgOAaQADAEAGAAQADgBADAAIAAAAIg8BeQA/grArgiQA4gtAsgQQBpAmAmBdQAUAvgCAtQAAABAHARQAIAXADAYQAIBNgtBLQgCAEgeAUQgmAagsAYQiIBIh+ADQgcABAcAvQAdAyAFgDIABABQAAgBAJAiQALAjAKABQAIAoAOACQAJAQAHAAQABAAABAAQABACABACQALBVAQACQANgPAHgLQALA3AGABQAAAAAGgMIAGgLQADAHADAEQASAzAFAGQACgBAJgNQAIgMAAgCQAIAcAGAdQAGARAUAVQAEAEANghQAjBEAoADQADAAAAAAIAAgBQACgJABgTQAAgJgBgGQAGAJAJAPQAaAoAHAAQAJABABgTQgBgXABgGQADAGANAkQANAgAIABQAFAAAWhRQAFgBAEgBQACAFACAFQAIAYgBASQgBACAFAAQAQACAbgqQAQgaAFgKQABAAABAAQAIAMACALQABAOACAFQACAKAFAHQANgLAbgmQAZgkAFgPQALAiAOABQAGABAKggQALglAFgMIADAnQgBADAFAAQAPABAjhNQAZg7AGgOQAHADAAASQAAACgBACQAAAEABAEIABACQAZg/AMhmQAKAOAEAOQgBADAFAAQAIABAFgzQADgzAAAAIABgxQgCgVgHgUQAGADAEAEQAFAKAIAIIANAgQABgEABgKQAAgMAAgCIAAgLQgBgegMgiQgMgcABgCQARAQAaAPIACAAQABAAAAAAQAAgBAAgBIABAAQAAgBgBAAQAAgBAAAAQABgpgbhYIgDgJQAPAOAIAGQADgBABgCQABgBAAgEQAAgNgQg7QgNg1gIgVQAFABAHAKQALAJAFAFQACADACADIACgBQAAgCAAgBQACgFAAgLQABgpgVgsQgUgqglgmQgCgGgBgBQACABANALQANAKADADQAGgBgLgcQgLgegVgXQgQgSgOgOQAFACAEAAgAHEB2IAAAAIAAAAg");
	this.shape.setTransform(52.8,66.4);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#66CCFF").s().p("AA7JwIADgDIgDAEgAg9pwIAAAAIAAABg");
	this.shape_1.setTransform(65.5,65.4);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_1},{t:this.shape}]}).wait(1));

}).prototype = getMCSymbolPrototype(lib.lion_maneGlow, new cjs.Rectangle(1.8,-2.9,102.2,138.8), null);


(lib.lion_legGlow = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 3
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#FFFF00").ss(5,1,1).p("AHjjhQANAkAoA5IAEAFQgZAEgWAGQgUAHgTAKIBjCAQBOByA4BSQA4BSgCAxQgBAvgJAcQAAABgBAAQgJAcgKAMQgkgDgVAIQgDABgDABQgGgEgIgCIgGAAQAAAAgBAAQAAAAgBAAQAAAAAAAAQgBAAAAAAQgBAAAAAAIgXAFQgKAGgGAJQgGAHgCAIQgBABAAABQgBABAAACQgBAAgBAAQgJACgDAEIgBACQAAABACACQACACABABIAGABQgBABAAABQgBACAAAAIAAABQAAADACACQADABAKABIAEABQABAAABABQAEACAEABQACABADAAQACABACAAQgBABAAAAQgEAEAAACQAAAEACABIACABIAdABQABAAAAAAQACAAABgCQAFAAADgBQAHgBADgBQABAAABAAQADABAFAAIADAAQgOAEAAAHQAAABACADQADADADABIAUABQgQAHAAAIQAAAFAEACQADACAOACIAQABQABgBACgBQAHAEAHABQADAAADABQgCABgCACQgIAIgBAEQAAAHAGABIAqACQAEAAACgEQAIABAFgBIAEAAQAEgBAEAAQACgBACAAQAOgCAJgGQAOgBAMgFIAVgLQABgBACgBQAEgGAEgEQAagSAeggQAVgWAWgcQAhgqAfgwQAZgnAAgEQAAgMgMgdQgRgmgKgYQgohiADhcQABg+AQhxQABgGABgFQAAgDABgCQAAgDAAgDQA/kjhOiWQg9hmiyAqQlHBFA1FVgANkGhQgBADAAADIgGAkQAAABgBABQgBAEgBAEQgKAegKAMQgcgCgVAFQABgCADgCQALgLAKgOQAZgeATgZQAFgHAFgGgAn0kOIhGBtQgMAFgOgJQgNAkgPAZQgIgjgMAIQgnA/gfAhQgGg6gTADQgcA9gZAKQgLgrgQgDQgRASgOAyQgZgfgWgJQAIAhAKAkQALArANAkQgBAaADBSQACAoABAcQABAbAAAOQABAcgWA7QgSAvgoAJQgBAAAAAAQgEgDgHgCQgUgFgaABQhAAFgDAsQgLACAAAGQAAABABACQACACACABIADAAQgKAFAAAFQAAAEACABQADACAKABIAKABQADgBABgDQABAAABABQADAEAFADIAAAAQgHAGAAADQAAAFAEABIAeABQADAAABgFQACABABABQAAAEABADQgNADAAAHQAAACACACQADAEADABIAOAAQgTAHAAAIQAAAFAFACQAFACATACIAWAAQABAAABAAQAGADAVADQgBABgBABQgMAIgBAEQAAAHAIABIA6ACQAFABADgEQACABACAAQAVAHANAAQAZABAOgKQAPgDAKgIQABgBACgBQADgBADAAQAEACAGAAQACAAACAAQAMADAFABQA+ABAWgmQAHgMABgPQABgNAAgBQABgMgDgMQAAgFgBgEQAAgHABgGIABgMQABgRABgQQADgxABgCQADgIAihpQACgGACgFQAVg9AXgtQAOgaAQgtQAVg6AahXQAGgWAGgVQARgTATiXQASiXgbhiQglCJgpBag");
	this.shape.setTransform(-47.5,65.8);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.lion_legGlow, new cjs.Rectangle(-156.7,-1.5,218.5,134.6), null);


(lib.lion_footGlow = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#FFFF00").ss(4,1,1).p("AN9hOQgQAVgTAXQgLAOgLALQgCACgCACQAVgFAcACQALgMAJgeQACgEABgEQAAgBABgBAN9hOQAAgBABAAQADABADABQgEAAgDgBgAOQhMQCCAUgVAaQgWAcgUAVQgeAggaASQgEAEgFAGQgBABgBABIgWALQgMAFgOABQgIAGgOACQgCAAgDABQgDAAgFABIgEAAQgFAAgIAAQgCAEgEAAIgqgCQgFgBAAgHQAAgEAJgIQABgCACgBQgDgBgCAAQgHgBgIgEQgBABgCABIgPgBQgOgCgEgCQgDgCAAgFQAAgIAPgHIgUgBQgCgBgDgDQgDgDAAgBQABgHANgEIgDAAQgEgBgEAAQgBAAgBAAQgDABgGABQgEABgFAAQgBACgCAAQAAAAAAAAIgegBIgBgBQgDgBAAgEQAAgCADgDQABgBABgBQgCAAgCgBQgCAAgDgBQgEgBgEgCQgBgBgBAAIgEgBQgJgBgDgBQgCgCAAgDIAAgBQAAgBAAgBQABgBABgBIgGgBQgCgBgCgCQgBgCAAgBIABgBQADgEAJgCQAAAAABAAQAAgCACgBQAAgBAAgBQADgIAFgHQAHgKAKgFIAWgFQABAAAAAAQAAAAABAAQAAAAABAAQAAAAABAAQAAAAABAAIAGAAQAIACAFAEQADgBADgBQAVgIAlADQAKgMAJgcQAAAAB3AKApGhXQjhhGgUA1QgRAvgpAJQAAAAgBAAQgEgDgGgCQgVgFgZABQhAAFgEAsQgKACgBAGQAAAAACACQACACABABIAEAAQgKAFgBAFQAAAEADABQADACAJABIALABQACgCACgCQABAAAAABQADAEAFADIAAAAQgGAGAAADQAAAFAEABIAdABQAEAAABgFQABABACABQAAAEABADQgNADgBAHQAAACADACQACAEADABIAPAAQgUAHAAAIQAAAFAFACQAGACATACIAVAAQACAAABAAQAFACAWAEQgCABgBABQgMAIAAAEQAAAHAIABIA6ACQAFABACgEQACABACAAQAVAHANAAQAaABAOgKQAPgDAJgIQACgBABgBQADgBADAAQAFACAGAAQACAAACAAQAMADAFABQA+ABAVgmQAHgMACgPQABgNAAgBQAAgMgCgMQgBgFgBgEQABgGAAgGIABgMQABgRABgQQABgSABgMg");
	this.shape.setTransform(102.4,27.5);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.lion_footGlow, new cjs.Rectangle(-1.9,12.8,208.8,29.6), null);


(lib.lion_backGlow = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#FFFF00").ss(6,1,1).p("AoBiQQBjAhC6AWIA9ACIFxgNQBlgOCtAVQBFATA7AkQgQAPgTAMQgBABgBABQhxBJh7AuQidA5iuALQiJAJiHgJQiggCighXQAHg4gQgvQAvgRgxiXg");
	this.shape.setTransform(110.3,13.9);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.lion_backGlow, new cjs.Rectangle(46.9,-7.4,126.7,42.5), null);


(lib.invisiblebox = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(255,255,255,0)").s().p("AhwDIIhZgEIAEmHIBOgEIDvAAIBSABIgCGKIhGAEg");
	this.shape.setTransform(-0.3,0);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.invisiblebox, new cjs.Rectangle(-20.5,-20,40.4,40), null);


(lib.blueglowpaws = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#0099FF").ss(4,1,1).p("AN9hOQgQAVgTAXQgLAOgLALQgCACgCACQAVgFAcACQALgMAJgeQACgEABgEQAAgBABgBAN9hOQAAgBABAAQADABADABQgEAAgDgBgAOQhMQCCAUgVAaQgWAcgUAVQgeAggaASQgEAEgFAGQgBABgBABIgWALQgMAFgOABQgIAGgOACQgCAAgDABQgDAAgFABIgEAAQgFAAgIAAQgCAEgEAAIgqgCQgFgBAAgHQAAgEAJgIQABgCACgBQgDgBgCAAQgHgBgIgEQgBABgCABIgPgBQgOgCgEgCQgDgCAAgFQAAgIAPgHIgUgBQgCgBgDgDQgDgDAAgBQABgHANgEIgDAAQgEgBgEAAQgBAAgBAAQgDABgGABQgEABgFAAQgBACgCAAQAAAAAAAAIgegBIgBgBQgDgBAAgEQAAgCADgDQABgBABgBQgCAAgCgBQgCAAgDgBQgEgBgEgCQgBgBgBAAIgEgBQgJgBgDgBQgCgCAAgDIAAgBQAAgBAAgBQABgBABgBIgGgBQgCgBgCgCQgBgCAAgBIABgBQADgEAJgCQAAAAABAAQAAgCACgBQAAgBAAgBQADgIAFgHQAHgKAKgFIAWgFQABAAAAAAQAAAAABAAQAAAAABAAQAAAAABAAQAAAAABAAIAGAAQAIACAFAEQADgBADgBQAVgIAlADQAKgMAJgcQAAAAB3AKApGhXQjhhGgUA1QgRAvgpAJQAAAAgBAAQgEgDgGgCQgVgFgZABQhAAFgEAsQgKACgBAGQAAAAACACQACACABABIAEAAQgKAFgBAFQAAAEADABQADACAJABIALABQACgCACgCQABAAAAABQADAEAFADIAAAAQgGAGAAADQAAAFAEABIAdABQAEAAABgFQABABACABQAAAEABADQgNADgBAHQAAACADACQACAEADABIAPAAQgUAHAAAIQAAAFAFACQAGACATACIAVAAQACAAABAAQAFACAWAEQgCABgBABQgMAIAAAEQAAAHAIABIA6ACQAFABACgEQACABACAAQAVAHANAAQAaABAOgKQAPgDAJgIQACgBABgBQADgBADAAQAFACAGAAQACAAACAAQAMADAFABQA+ABAVgmQAHgMACgPQABgNAAgBQAAgMgCgMQgBgFgBgEQABgGAAgGIABgMQABgRABgQQABgSABgMg");
	this.shape.setTransform(102.4,27.5);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.blueglowpaws, new cjs.Rectangle(-1.9,12.8,208.8,29.6), null);


(lib.blueglowmouth = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#0099FF").s().p("AAEDDQgugCgqgYIAAgBQgggSgVgdQgJgNgHgPQgpgjAChGIAAgBQABg5AagqIABAAQAzhVCEAEQBzADAoBOIAAAAQAUAlgBA2QgBAUgEAQQgBAugdAtIAAAAIgQAWQg0BDhSAAIgEAAgAiEgLIAAAAQgBAqAXAUQAGAFADAHQAFANAIAKQAOATAUAMIABAAQAcARAeABQA3ABAjgtIANgRIAAAAQATgfABggIABgIQAEgLAAgOQABglgNgZIAAAAQgcgvhMgCQhdgDgmA4IABgBQgSAdgBApg");
	this.shape.setTransform(16.3,16.4);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.blueglowmouth, new cjs.Rectangle(-3,-3,45.8,38.9), null);


(lib.blueglowmane = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#0099FF").ss(6,1,1).p("AFzntIANABQACAAABAAQABgBAAgDQAAgSgYgWQgogkgzgXQgHgDgGgCQgDgBgDgCQgMgFgMgBQgtgLgoAKQABgDACgDQANgVABABQgEgag0AVQgDAAgDACQgtATgDgEQgUghgVgGQg3AegNgJQgQgKgVgDQgYgBgLgCIgBAIQABAHAHAOQgbAAgbAKQgIABgMABQgBAEgNAKQgVALgYASQgVAPglAcQAAADAAABQABABADAAQABAAABAAQgDAEAAAGQAAACABABQgHAGgIAGQg3AtgOAaQADAEAGAAQADgBADAAIAAAAIg8BeQA/grArgiQA4gtAsgQQBpAmAmBdQAUAvgCAtQAAABAHARQAIAXADAYQAIBNgtBLQgCAEgeAUQgmAagsAYQiIBIh+ADQgcABAcAvQAdAyAFgDIABABQAAgBAJAiQALAjAKABQAIAoAOACQAJAQAHAAQABAAABAAQABACABACQALBVAQACQANgPAHgLQALA3AGABQAAAAAGgMIAGgLQADAHADAEQASAzAFAGQACgBAJgNQAIgMAAgCQAIAcAGAdQAGARAUAVQAEAEANghQAjBEAoADQADAAAAAAIAAgBQACgJABgTQAAgJgBgGQAGAJAJAPQAaAoAHAAQAJABABgTQgBgXABgGQADAGANAkQANAgAIABQAFAAAWhRQAFgBAEgBQACAFACAFQAIAYgBASQgBACAFAAQAQACAbgqQAQgaAFgKQABAAABAAQAIAMACALQABAOACAFQACAKAFAHQANgLAbgmQAZgkAFgPQALAiAOABQAGABAKggQALglAFgMIADAnQgBADAFAAQAPABAjhNQAZg7AGgOQAHADAAASQAAACgBACQAAAEABAEIABACQAZg/AMhmQAKAOAEAOQgBADAFAAQAIABAFgzQADgzAAAAIABgxQgCgVgHgUQAGADAEAEQAFAKAIAIIANAgQABgEABgKQAAgMAAgCIAAgLQgBgegMgiQgMgcABgCQARAQAaAPIACAAQABAAAAAAQAAgBAAgBIABAAQAAgBgBAAQAAgBAAAAQABgpgbhYIgDgJQAPAOAIAGQADgBABgCQABgBAAgEQAAgNgQg7QgNg1gIgVQAFABAHAKQALAJAFAFQACADACADIACgBQAAgCAAgBQACgFAAgLQABgpgVgsQgUgqglgmQgCgGgBgBQACABANALQANAKADADQAGgBgLgcQgLgegVgXQgQgSgOgOQAFACAEAAg");
	this.shape.setTransform(52.8,66.4);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f().s("#FFFF00").ss(6,1,1).p("AAAAAIAAAAIAAAAg");
	this.shape_1.setTransform(98,78.2);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("#66CCFF").s().p("AA7JwIADgDIgDAEgAg9pwIAAAAIAAABg");
	this.shape_2.setTransform(65.5,65.4);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_2},{t:this.shape_1},{t:this.shape}]}).wait(1));

}).prototype = getMCSymbolPrototype(lib.blueglowmane, new cjs.Rectangle(1.8,-2.9,102.2,138.8), null);


(lib.blueglowlegs = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 3
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#0099FF").ss(5,1,1).p("AHjjhQANAkAoA5IAEAFQgZAEgWAGQgUAHgTAKIBjCAQBOByA4BSQA4BSgCAxQgBAvgJAcQAAABgBAAQgJAcgKAMQgkgDgVAIQgDABgDABQgGgEgIgCIgGAAQAAAAgBAAQAAAAgBAAQAAAAAAAAQgBAAAAAAQgBAAAAAAIgXAFQgKAGgGAJQgGAHgCAIQgBABAAABQgBABAAACQgBAAgBAAQgJACgDAEIgBACQAAABACACQACACABABIAGABQgBABAAABQgBACAAAAIAAABQAAADACACQADABAKABIAEABQABAAABABQAEACAEABQACABADAAQACABACAAQgBABAAAAQgEAEAAACQAAAEACABIACABIAdABQABAAAAAAQACAAABgCQAFAAADgBQAHgBADgBQABAAABAAQADABAFAAIADAAQgOAEAAAHQAAABACADQADADADABIAUABQgQAHAAAIQAAAFAEACQADACAOACIAQABQABgBACgBQAHAEAHABQADAAADABQgCABgCACQgIAIgBAEQAAAHAGABIAqACQAEAAACgEQAIABAFgBIAEAAQAEgBAEAAQACgBACAAQAOgCAJgGQAOgBAMgFIAVgLQABgBACgBQAEgGAEgEQAagSAeggQAVgWAWgcQAhgqAfgwQAZgnAAgEQAAgMgMgdQgRgmgKgYQgohiADhcQABg+AQhxQABgGABgFQAAgDABgCQAAgDAAgDQA/kjhOiWQg9hmiyAqQlHBFA1FVgANkGhQgBADAAADIgGAkQAAABgBABQgBAEgBAEQgKAegKAMQgcgCgVAFQABgCADgCQALgLAKgOQAZgeATgZQAFgHAFgGgAn0kOIhGBtQgMAFgOgJQgNAkgPAZQgIgjgMAIQgnA/gfAhQgGg6gTADQgcA9gZAKQgLgrgQgDQgRASgOAyQgZgfgWgJQAIAhAKAkQALArANAkQgBAaADBSQACAoABAcQABAbAAAOQABAcgWA7QgSAvgoAJQgBAAAAAAQgEgDgHgCQgUgFgaABQhAAFgDAsQgLACAAAGQAAABABACQACACACABIADAAQgKAFAAAFQAAAEACABQADACAKABIAKABQADgBABgDQABAAABABQADAEAFADIAAAAQgHAGAAADQAAAFAEABIAeABQADAAABgFQACABABABQAAAEABADQgNADAAAHQAAACACACQADAEADABIAOAAQgTAHAAAIQAAAFAFACQAFACATACIAWAAQABAAABAAQAGADAVADQgBABgBABQgMAIgBAEQAAAHAIABIA6ACQAFABADgEQACABACAAQAVAHANAAQAZABAOgKQAPgDAKgIQABgBACgBQADgBADAAQAEACAGAAQACAAACAAQAMADAFABQA+ABAWgmQAHgMABgPQABgNAAgBQABgMgDgMQAAgFgBgEQAAgHABgGIABgMQABgRABgQQADgxABgCQADgIAihpQACgGACgFQAVg9AXgtQAOgaAQgtQAVg6AahXQAGgWAGgVQARgTATiXQASiXgbhiQglCJgpBag");
	this.shape.setTransform(-47.5,65.8);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.blueglowlegs, new cjs.Rectangle(-156.7,-1.5,218.5,134.6), null);


(lib.blueglowback = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#0099FF").ss(6,1,1).p("AoBiQQBjAhC6AWIA9ACIFxgNQBlgOCtAVQBFATA7AkQgQAPgTAMQgBABgBABQhxBJh7AuQidA5iuALQiJAJiHgJQiggCighXQAHg4gQgvQAvgRgxiXg");
	this.shape.setTransform(110.3,13.9);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.blueglowback, new cjs.Rectangle(46.9,-7.4,126.7,42.5), null);


(lib.LionTorso_wet = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"final":0,"final_loop":1});

	// Layer 7
	this.instance = new lib.LionTorso_wet0002();
	this.instance.parent = this;
	this.instance.setTransform(-125.5,-66.9,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(2));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-125.5,-66.9,259,146);


(lib.LionTailEnd = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#5A3425").s().p("AgJCKQgIgRgJgGQgDgBgFgFIgGAIQgMASgGAAQgMAAgCgSIgBgcIgCABIgFABQgIAAgDgIIAAgJQAAgMAKggQAKgdgCgPQABgLAMgRQAKgyAwgpQAZgVARAAQAQAAADASQAWASAAAnIAAAKQALASAAAXQAAAYgLAjQgQA1gbADQgEAMgBAdQgGAbgNAAQgOAAgJgRg");

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.LionTailEnd, new cjs.Rectangle(-9.2,-15.5,18.4,31.1), null);


(lib.star_2_anim = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Star
	this.instance = new lib.SmallStar("synched",0);
	this.instance.parent = this;
	this.instance.setTransform(0.1,0.3,0.6,0.6);

	this.timeline.addTween(cjs.Tween.get(this.instance).to({guide:{path:[0.1,0.2,-4.2,-0.7,-6.2,-1.6,-9.1,-2.8,-9.1,-4.5,-9.1,-6.3,-6,-7.7,-4.2,-8.6,0.7,-10,5.6,-11.4,7.5,-12.3,10.6,-13.8,10.6,-15.6,10.6,-17.5,7.3,-18.9,5.3,-19.8,0.1,-21.1,-5.1,-22.4,-7,-23.2,-10.3,-24.5,-10.3,-26.3,-10.3,-28,-7.2,-29.3,-5.7,-30,-1.7,-31.1], orient:'auto'},alpha:0.102},16).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-5.1,-4.7,10.5,10);


(lib.star_1_anim = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Star
	this.instance = new lib.LargeStar("synched",0);
	this.instance.parent = this;
	this.instance.setTransform(0.1,0.3,0.6,0.6);

	this.timeline.addTween(cjs.Tween.get(this.instance).to({guide:{path:[0.1,0.2,4.5,-0.7,6.5,-1.6,9.4,-2.8,9.4,-4.5,9.4,-6.3,6.3,-7.7,4.5,-8.6,-0.4,-10,-5.3,-11.4,-7.2,-12.3,-10.3,-13.8,-10.3,-15.6,-10.3,-17.5,-7,-18.9,-5,-19.8,0.1,-21.1,5.4,-22.4,7.3,-23.2,10.6,-24.5,10.6,-26.3,10.6,-28,7.5,-29.3,6,-30,2,-31.1], orient:'auto'},alpha:0.102},13).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-6.9,-6.4,14,13.3);


(lib.sparkle2 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.innerSparkle = new lib.star_2_anim();
	this.innerSparkle.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.innerSparkle).wait(1));

}).prototype = getMCSymbolPrototype(lib.sparkle2, new cjs.Rectangle(-5.2,-4.7,10.6,10), null);


(lib.sparkle1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.innerSparkle = new lib.star_1_anim();
	this.innerSparkle.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.innerSparkle).wait(1));

}).prototype = getMCSymbolPrototype(lib.sparkle1, new cjs.Rectangle(-6.9,-6.4,14,13.3), null);


(lib.Running_drop = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.instance = new lib.Wet_drop();
	this.instance.parent = this;
	this.instance.setTransform(4.8,10,1,1,0,0,0,4.8,10);
	this.instance.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,4);
	new cjs.ButtonHelper(this.instance, 0, 1, 1);

	this.timeline.addTween(cjs.Tween.get(this.instance).to({y:146.2},15).to({regX:4.5,scaleX:0.1,scaleY:0.1,y:182.5},4).to({_off:true},1).wait(5));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-10,-10,37,48);


(lib.lion_maneMud_001 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_loop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":80,glowclean:81,glowclean_loop:82,"final":83,"final_loop":84});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(169,114,78,0.902)").s().p("AjOFkQgGgcgDgHQgwACgUgWQgLgNAAgRQAAggAWgkQAWgkAAgDIgCgUQgWgKgXgVQgtgmAAgXQAAgjAIgmQgBgIACgMQAGghAHgJIADgDIADgQIgHgUQgHgSAAgJQAAgiAOgXQAMgWARABIAMgQQAYgaAdgRQANgHALgEQAJgPAFgMQAkhTBeAmQARAHAQAKIAJACIAEABIATgFQAqgKAcAIQAaAIAFAVIAKAOIADAHIAGgBIAQABQANgOAZAGQAXAGALANQAwAOAeAfQAXAYAJAZIAEAOQAFADADAEQghgNgegJQAEAAAAgJIAAgJIgGgBQgOgDgDAJIgeAKQgSACgRALIABgLIgEgIQgBgFgIAAIgPAMIgKAKIgDAHQgGAMgJAGIgHgQQgGgGgCAFIgCAFIgBAAQgIAKAAAPIgVgBQABgUgFgWIgCgEQgSgggcgbIgCgCQgOgHgLgMIgagBIgMAGIgDAFQgFgBgFAEQgDADgIADIgGAKIgIAIIgIAUIgLAMIgBAJIgEACIgDAQQgEAYAAAXIADAFQgDAJACAGQAGAYAPATIACAHIAHADIABAHIAWAQIgJgIQAJgDALgBIgIAPIgEAAIgCABIgBABIAAACQgKABgGAHIgIAJIgCAOIADASQADAagMARIgDAQQgJA1ALAmQACAEAGABQAFABgBAEIgGA6IAEAJIACAHIACAAQADgCAEgGQAIgLAKgBIgCAMQgJArANAkIAAgCQAIgUATgJQgGAKgBAKIgDAWQgaANgqAAQgPAAgKgNQgMA2gmAAQgjAAgMgagAB1icIAFgHIgBAHg");
	this.shape.setTransform(40.1,44.3);

	this.instance = new lib.lion_maneGlow();
	this.instance.parent = this;
	this.instance.setTransform(40.9,79.2,1.08,1.1,0,0,180,52.6,66.5);

	this.glow = new lib.blueglowmane();
	this.glow.parent = this;
	this.glow.setTransform(40.9,79.2,1.08,1.1,0,0,180,52.6,66.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape}]}).to({state:[]},2).to({state:[{t:this.shape},{t:this.instance}]},2).to({state:[]},2).to({state:[{t:this.glow}]},75).to({state:[]},2).to({state:[]},181).wait(40));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(5.9,6.1,68.6,76.4);


(lib.left_over_bubbles_sparse = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 15
	this.instance = new lib.M_Wash_Bubble_1();
	this.instance.parent = this;
	this.instance.setTransform(59.6,9,0.075,0.075,-155.3,0,0,11.1,11.2);
	this.instance.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_1 = new lib.M_Wash_Bubble_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(46.5,10.1,0.439,0.439,-153.7,0,0,11.2,11.1);
	this.instance_1.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_2 = new lib.M_Wash_Bubble_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(55.1,9,0.162,0.162,-155.3,0,0,11.2,11.2);
	this.instance_2.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_3 = new lib.M_Wash_Bubble_1();
	this.instance_3.parent = this;
	this.instance_3.setTransform(38.2,13,0.188,0.188,-155.4,0,0,11.1,10.7);
	this.instance_3.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_4 = new lib.M_Wash_Bubble_1();
	this.instance_4.parent = this;
	this.instance_4.setTransform(40.7,8.6,0.28,0.28,-155.4,0,0,11.2,11.2);
	this.instance_4.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_5 = new lib.M_Wash_Bubble_1();
	this.instance_5.parent = this;
	this.instance_5.setTransform(36.5,10.9,0.165,0.165,0,0,0,11,11);
	this.instance_5.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]}).wait(1));

}).prototype = getMCSymbolPrototype(lib.left_over_bubbles_sparse, new cjs.Rectangle(23.8,-13.3,50.1,48), null);


(lib.left_over_bubbles_few = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 15
	this.instance = new lib.M_Wash_Bubble_1();
	this.instance.parent = this;
	this.instance.setTransform(42.3,6.2,0.075,0.075,-155.3,0,0,11,11.2);
	this.instance.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_1 = new lib.M_Wash_Bubble_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(43.3,4.3,0.075,0.075,-155.3,0,0,11,11.2);
	this.instance_1.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_2 = new lib.M_Wash_Bubble_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(39.9,6.5,0.075,0.075,-155.3,0,0,11.1,11.2);
	this.instance_2.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_3 = new lib.M_Wash_Bubble_1();
	this.instance_3.parent = this;
	this.instance_3.setTransform(54,11,0.075,0.075,-155.3,0,0,11,11.2);
	this.instance_3.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_4 = new lib.M_Wash_Bubble_1();
	this.instance_4.parent = this;
	this.instance_4.setTransform(46.5,10.1,0.439,0.439,-153.7,0,0,11.2,11.1);
	this.instance_4.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_5 = new lib.M_Wash_Bubble_1();
	this.instance_5.parent = this;
	this.instance_5.setTransform(52.8,6.1,0.28,0.28,-155.4,0,0,11.2,11.2);
	this.instance_5.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]}).wait(1));

}).prototype = getMCSymbolPrototype(lib.left_over_bubbles_few, new cjs.Rectangle(23.8,-13.3,50.1,48), null);


(lib.left_over_bubbles = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 15
	this.instance = new lib.M_Wash_Bubble_1();
	this.instance.parent = this;
	this.instance.setTransform(70.8,4,0.404,0.404,4.9,0,0,11.1,10.3);
	this.instance.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_1 = new lib.M_Wash_Bubble_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(64.4,1.4,0.289,0.289,4.9,0,0,11.1,10.3);
	this.instance_1.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_2 = new lib.M_Wash_Bubble_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(31,4.8,0.289,0.289,4.9,0,0,11.1,10);
	this.instance_2.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_3 = new lib.M_Wash_Bubble_1();
	this.instance_3.parent = this;
	this.instance_3.setTransform(29.7,12.7,0.431,0.431,4.9,0,0,11.3,11.2);
	this.instance_3.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_4 = new lib.M_Wash_Bubble_1();
	this.instance_4.parent = this;
	this.instance_4.setTransform(34.6,7,0.253,0.253,160.3,0,0,10.8,10.8);
	this.instance_4.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_5 = new lib.M_Wash_Bubble_1();
	this.instance_5.parent = this;
	this.instance_5.setTransform(55.1,9,0.162,0.162,-155.3,0,0,11.2,11.2);
	this.instance_5.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_6 = new lib.M_Wash_Bubble_1();
	this.instance_6.parent = this;
	this.instance_6.setTransform(47.2,-5.1,0.267,0.267,-155.4,0,0,11.5,11.1);
	this.instance_6.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_7 = new lib.M_Wash_Bubble_1();
	this.instance_7.parent = this;
	this.instance_7.setTransform(20.1,12.2,0.221,0.221,-155.4,0,0,11.3,11);
	this.instance_7.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_8 = new lib.M_Wash_Bubble_1();
	this.instance_8.parent = this;
	this.instance_8.setTransform(20.2,17,0.162,0.162,-155.3,0,0,11.2,11.1);
	this.instance_8.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_9 = new lib.M_Wash_Bubble_1();
	this.instance_9.parent = this;
	this.instance_9.setTransform(38.2,13,0.188,0.188,-155.4,0,0,11.1,10.7);
	this.instance_9.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_10 = new lib.M_Wash_Bubble_1();
	this.instance_10.parent = this;
	this.instance_10.setTransform(40.7,8.6,0.28,0.28,-155.4,0,0,11.2,11.2);
	this.instance_10.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_11 = new lib.M_Wash_Bubble_1();
	this.instance_11.parent = this;
	this.instance_11.setTransform(82.6,4.9,0.124,0.124,-155.3,0,0,10.5,11.2);
	this.instance_11.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_12 = new lib.M_Wash_Bubble_1();
	this.instance_12.parent = this;
	this.instance_12.setTransform(36.5,10.9,0.165,0.165,0,0,0,11,11);
	this.instance_12.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_12},{t:this.instance_11},{t:this.instance_10},{t:this.instance_9},{t:this.instance_8},{t:this.instance_7},{t:this.instance_6},{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]}).wait(1));

}).prototype = getMCSymbolPrototype(lib.left_over_bubbles, new cjs.Rectangle(5.3,-21.9,91.8,57.3), null);


(lib.footmudfront = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_loop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":260,"final":261,"final_loop":262});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(169,114,78,0.8)").s().p("ABwEkQgqgNgEAAQg8AAgUgCIgEAEIgCADQguAEgrgPQgIAEgJgBIgEAAIgVgKQAAgFgBgDIgEgFIgIADIgEACQg6gbgjg6Igfg1QgCgDABgEQgMgPgCgXIgJgTIgIgKIgCiMIgDgBQgFgTgCgVIATAPIgDgIIgKgXQAAgGAGgNIAFgQQgCgJABgIQACgQAQAAIAHABIgEgTQgEgMAAgIQADgMAFgMQALgXAQAAQAXAAANAmQAOAlADAAQAZAAAPAHQAQAIAAAOIAEAeQAAAJADANQARgCAMAOQAJALAAAKQAAALACAJIABAPIABAKQARgVAXgWQAFgEAEgGIAEAZIAQAVQgFAMAFAMQAHAOgCAPIgYgiQAWAjANAhIABAAQACALAKAJQAMAIAGAOIgVgKIABACQArAZAeAgIAqACIAAgBQBCASA5gXIABgBIAFAAQAiAFAMAJQATAMASAWQAVAXAAANIAAABQADAEAAAFIgCAIIgCAIIgBALIgBABIgWgDIgKAHIgEAYIAEAMQgCAFgFAAIgHADIgJgBIgDgHQgYgOgigBIgDAAIgHAEQgFAJAAANIAAAGIACAFQASAEASABIgMAHQgYANgKAAQggAAgwgNgAjIj1QgEgGAAgFQAAgbAYgDQAYgDAAAUQAAAigcgBQgKAAgGgJg");
	this.shape.setTransform(17.3,33.5);

	this.instance = new lib.left_over_bubbles_few();
	this.instance.parent = this;
	this.instance.setTransform(12.5,40.8,0.838,0.838,-88.7,0,0,46,10.1);

	this.instance_1 = new lib.left_over_bubbles_sparse();
	this.instance_1.parent = this;
	this.instance_1.setTransform(27.9,53.9,1,1,0,0,0,46.1,10.1);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape}]}).to({state:[{t:this.instance_1},{t:this.instance}]},2).to({state:[{t:this.shape}]},2).to({state:[]},2).to({state:[{t:this.instance_1},{t:this.instance}]},54).to({state:[]},201).to({state:[]},1).wait(40));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-16.4,3,67.4,61);


(lib.Bubbles_together = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// M_Wash_Bubble
	this.instance = new lib.M_Wash_Bubble_1();
	this.instance.parent = this;
	this.instance.setTransform(30.1,18.9,0.303,0.303,-155.3,0,0,11,10.9);
	this.instance.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_1 = new lib.M_Wash_Bubble_pop_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(30.2,18.9,0.757,0.757,-155.3,0,0,10.9,11);
	this.instance_1.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance}]},38).to({state:[{t:this.instance_1}]},2).to({state:[]},2).wait(50));
	this.timeline.addTween(cjs.Tween.get(this.instance).to({regX:10.9,regY:11,scaleX:0.76,scaleY:0.76,x:30.2},38).to({_off:true},2).wait(52));

	// M_Wash_Bubble
	this.instance_2 = new lib.M_Wash_Bubble_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(24.5,20.9,0.313,0.313,-155.3,0,0,11.1,11.1);
	this.instance_2.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_3 = new lib.M_Wash_Bubble_pop_1();
	this.instance_3.parent = this;
	this.instance_3.setTransform(24.6,20.9,0.757,0.757,-155.3,0,0,11,11);
	this.instance_3.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_2}]}).to({state:[{t:this.instance_2}]},40).to({state:[{t:this.instance_3}]},2).to({state:[]},2).wait(48));
	this.timeline.addTween(cjs.Tween.get(this.instance_2).to({regX:11,regY:11,scaleX:0.76,scaleY:0.76,x:24.6},40).to({_off:true},2).wait(50));

	// M_Wash_Bubble
	this.instance_4 = new lib.M_Wash_Bubble_1();
	this.instance_4.parent = this;
	this.instance_4.setTransform(39.6,16.1,0.287,0.287,-155.3,0,0,10.8,10.8);
	this.instance_4.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_5 = new lib.M_Wash_Bubble_pop_1();
	this.instance_5.parent = this;
	this.instance_5.setTransform(39.6,16.1,0.757,0.757,-155.3,0,0,11,11);
	this.instance_5.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_4}]}).to({state:[{t:this.instance_4}]},34).to({state:[{t:this.instance_5}]},2).to({state:[]},2).wait(54));
	this.timeline.addTween(cjs.Tween.get(this.instance_4).to({regX:11,regY:11,scaleX:0.76,scaleY:0.76},34).to({_off:true},2).wait(56));

	// M_Wash_Bubble
	this.instance_6 = new lib.M_Wash_Bubble_1();
	this.instance_6.parent = this;
	this.instance_6.setTransform(9.9,-2.5,0.199,0.199,-155.3,0,0,11,10.7);
	this.instance_6.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_7 = new lib.M_Wash_Bubble_pop_1();
	this.instance_7.parent = this;
	this.instance_7.setTransform(9.8,-2.5,0.757,0.757,-155.3,0,0,11.1,11);
	this.instance_7.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_6}]}).to({state:[{t:this.instance_7}]},32).to({state:[{t:this.instance_7}]},2).to({state:[]},2).wait(56));
	this.timeline.addTween(cjs.Tween.get(this.instance_6).to({_off:true,regX:11.1,regY:11,scaleX:0.76,scaleY:0.76,x:9.8},32).wait(60));

	// M_Wash_Bubble
	this.instance_8 = new lib.M_Wash_Bubble_1();
	this.instance_8.parent = this;
	this.instance_8.setTransform(25.7,-1.5,0.162,0.162,-155.3,0,0,11.2,11.2);
	this.instance_8.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_9 = new lib.M_Wash_Bubble_pop_1();
	this.instance_9.parent = this;
	this.instance_9.setTransform(25.6,-1.5,0.757,0.757,-155.3,0,0,11.1,11);
	this.instance_9.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_8}]}).to({state:[{t:this.instance_9}]},36).to({state:[{t:this.instance_9}]},2).to({state:[]},2).wait(52));
	this.timeline.addTween(cjs.Tween.get(this.instance_8).to({_off:true,regX:11.1,regY:11,scaleX:0.76,scaleY:0.76,x:25.6},36).wait(56));

	// M_Wash_Bubble
	this.instance_10 = new lib.M_Wash_Bubble_1();
	this.instance_10.parent = this;
	this.instance_10.setTransform(22.2,6,0.108,0.108,-155.3,0,0,11.1,11.8);
	this.instance_10.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_11 = new lib.M_Wash_Bubble_pop_1();
	this.instance_11.parent = this;
	this.instance_11.setTransform(22,6,0.757,0.757,-155.3,0,0,11.2,10.9);
	this.instance_11.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_10}]}).to({state:[{t:this.instance_11}]},30).to({state:[{t:this.instance_11}]},2).to({state:[]},2).wait(58));
	this.timeline.addTween(cjs.Tween.get(this.instance_10).to({_off:true,regX:11.2,regY:10.9,scaleX:0.76,scaleY:0.76,x:22},30).wait(62));

	// M_Wash_Bubble
	this.instance_12 = new lib.M_Wash_Bubble_1();
	this.instance_12.parent = this;
	this.instance_12.setTransform(29.2,-9,0.119,0.119,-155.3,0,0,11.5,11);
	this.instance_12.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_13 = new lib.M_Wash_Bubble_pop_1();
	this.instance_13.parent = this;
	this.instance_13.setTransform(29.1,-9,0.757,0.757,-155.3,0,0,11.1,11);
	this.instance_13.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_12}]}).to({state:[{t:this.instance_13}]},32).to({state:[{t:this.instance_13}]},2).to({state:[]},2).wait(56));
	this.timeline.addTween(cjs.Tween.get(this.instance_12).to({_off:true,regX:11.1,scaleX:0.76,scaleY:0.76,x:29.1},32).wait(60));

	// M_Wash_Bubble
	this.instance_14 = new lib.M_Wash_Bubble_1();
	this.instance_14.parent = this;
	this.instance_14.setTransform(42.2,-3.1,0.271,0.271,-155.3,0,0,10.3,11.3);
	this.instance_14.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_15 = new lib.M_Wash_Bubble_pop_1();
	this.instance_15.parent = this;
	this.instance_15.setTransform(42.2,-3.1,0.757,0.757,-155.3,0,0,11,11.1);
	this.instance_15.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_14}]}).to({state:[{t:this.instance_15}]},30).to({state:[{t:this.instance_15}]},2).to({state:[]},2).wait(58));
	this.timeline.addTween(cjs.Tween.get(this.instance_14).to({_off:true,regX:11,regY:11.1,scaleX:0.76,scaleY:0.76},30).wait(62));

	// M_Wash_Bubble
	this.instance_16 = new lib.M_Wash_Bubble_1();
	this.instance_16.parent = this;
	this.instance_16.setTransform(48.3,9,0.125,0.125,-155.3,0,0,11,10.5);
	this.instance_16.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get(this.instance_16).to({regY:11,scaleX:0.76,scaleY:0.76,x:48.4,y:8.9},24).wait(2).to({_off:true},2).wait(64));

	// M_Wash_Bubble
	this.instance_17 = new lib.M_Wash_Bubble_1();
	this.instance_17.parent = this;
	this.instance_17.setTransform(32.6,-16.6,0.076,0.076,-155.3,0,0,10.8,11);
	this.instance_17.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get(this.instance_17).to({regX:11,regY:11.1,scaleX:0.76,scaleY:0.76,y:-16.7},20).wait(2).to({_off:true},2).wait(68));

	// M_Wash_Bubble
	this.instance_18 = new lib.M_Wash_Bubble_1();
	this.instance_18.parent = this;
	this.instance_18.setTransform(35.5,5.1,0.103,0.103,-155.3,0,0,10.3,10.8);
	this.instance_18.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get(this.instance_18).to({regX:11,regY:11.1,scaleX:0.76,scaleY:0.76,x:32.6,y:7.6},22).wait(2).to({regY:11,x:35.5,y:5.1},0).to({_off:true},2).wait(66));

	// M_Wash_Bubble
	this.instance_19 = new lib.M_Wash_Bubble_1();
	this.instance_19.parent = this;
	this.instance_19.setTransform(56,0.3,0.124,0.124,-155.3,0,0,10.5,11.2);
	this.instance_19.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_20 = new lib.M_Wash_Bubble_pop_1();
	this.instance_20.parent = this;
	this.instance_20.setTransform(52,-4.5,0.686,0.686,-155.4,0,0,10.3,11.2);
	this.instance_20.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_19}]}).to({state:[{t:this.instance_19}]},24).to({state:[{t:this.instance_20}]},2).to({state:[]},2).wait(64));
	this.timeline.addTween(cjs.Tween.get(this.instance_19).to({regX:10.3,scaleX:0.69,scaleY:0.69,rotation:-155.4,x:52,y:-4.5},24).to({_off:true},2).wait(66));

	// M_Wash_Bubble
	this.instance_21 = new lib.M_Wash_Bubble_1();
	this.instance_21.parent = this;
	this.instance_21.setTransform(52.4,20,0.067,0.067,-155.3,0,0,11.8,11.1);
	this.instance_21.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_22 = new lib.M_Wash_Bubble_pop_1();
	this.instance_22.parent = this;
	this.instance_22.setTransform(52.4,19.8,0.757,0.757,-155.3,0,0,11.2,11.2);
	this.instance_22.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_21}]}).to({state:[{t:this.instance_21}]},22).to({state:[{t:this.instance_22}]},8).to({state:[{t:this.instance_22}]},2).to({state:[]},2).wait(58));
	this.timeline.addTween(cjs.Tween.get(this.instance_21).to({regX:11.7,regY:11.2,scaleX:0.53,scaleY:0.53,rotation:-155.4,x:46.9,y:21.6},22).to({_off:true,regX:11.2,scaleX:0.76,scaleY:0.76,rotation:-155.3,x:52.4,y:19.8},8).wait(62));

	// M_Wash_Bubble
	this.instance_23 = new lib.M_Wash_Bubble_1();
	this.instance_23.parent = this;
	this.instance_23.setTransform(38.5,-8.5,0.4,0.4,0,0,0,11,11);
	this.instance_23.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_24 = new lib.M_Wash_Bubble_pop_1();
	this.instance_24.parent = this;
	this.instance_24.setTransform(38.5,-8.5,1,1,0,0,0,11,11);
	this.instance_24.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_23}]}).to({state:[{t:this.instance_23}]},38).to({state:[{t:this.instance_24}]},2).to({state:[]},2).wait(50));
	this.timeline.addTween(cjs.Tween.get(this.instance_23).to({scaleX:1,scaleY:1},38).to({_off:true},2).wait(52));

	// M_Wash_Bubble
	this.instance_25 = new lib.M_Wash_Bubble_1();
	this.instance_25.parent = this;
	this.instance_25.setTransform(44,-14,0.413,0.413,0,0,0,11,11);
	this.instance_25.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_26 = new lib.M_Wash_Bubble_pop_1();
	this.instance_26.parent = this;
	this.instance_26.setTransform(44,-14,1,1,0,0,0,11,11);
	this.instance_26.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_25}]}).to({state:[{t:this.instance_25}]},40).to({state:[{t:this.instance_26}]},2).to({state:[]},2).wait(48));
	this.timeline.addTween(cjs.Tween.get(this.instance_25).to({scaleX:1,scaleY:1},40).to({_off:true},2).wait(50));

	// M_Wash_Bubble
	this.instance_27 = new lib.M_Wash_Bubble_1();
	this.instance_27.parent = this;
	this.instance_27.setTransform(28.7,0,0.379,0.379,0,0,0,11,11);
	this.instance_27.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_28 = new lib.M_Wash_Bubble_pop_1();
	this.instance_28.parent = this;
	this.instance_28.setTransform(28.7,0,1,1,0,0,0,11,11);
	this.instance_28.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_27}]}).to({state:[{t:this.instance_27}]},34).to({state:[{t:this.instance_28}]},2).to({state:[]},2).wait(54));
	this.timeline.addTween(cjs.Tween.get(this.instance_27).to({scaleX:1,scaleY:1},34).to({_off:true},2).wait(56));

	// M_Wash_Bubble
	this.instance_29 = new lib.M_Wash_Bubble_1();
	this.instance_29.parent = this;
	this.instance_29.setTransform(74.5,6,0.263,0.263,0,0,0,11,11);
	this.instance_29.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_30 = new lib.M_Wash_Bubble_pop_1();
	this.instance_30.parent = this;
	this.instance_30.setTransform(74.5,6,1,1,0,0,0,11,11);
	this.instance_30.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_29}]}).to({state:[{t:this.instance_30}]},32).to({state:[{t:this.instance_30}]},2).to({state:[]},2).wait(56));
	this.timeline.addTween(cjs.Tween.get(this.instance_29).to({_off:true,scaleX:1,scaleY:1},32).wait(60));

	// M_Wash_Bubble
	this.instance_31 = new lib.M_Wash_Bubble_1();
	this.instance_31.parent = this;
	this.instance_31.setTransform(54.9,13.5,0.214,0.214,0,0,0,11,11.2);
	this.instance_31.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_32 = new lib.M_Wash_Bubble_pop_1();
	this.instance_32.parent = this;
	this.instance_32.setTransform(54.9,13.5,1,1,0,0,0,11,11);
	this.instance_32.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_31}]}).to({state:[{t:this.instance_32}]},36).to({state:[{t:this.instance_32}]},2).to({state:[]},2).wait(52));
	this.timeline.addTween(cjs.Tween.get(this.instance_31).to({_off:true,regY:11,scaleX:1,scaleY:1},36).wait(56));

	// M_Wash_Bubble
	this.instance_33 = new lib.M_Wash_Bubble_1();
	this.instance_33.parent = this;
	this.instance_33.setTransform(55,2.5,0.143,0.143,0,0,0,10.8,11.2);
	this.instance_33.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_34 = new lib.M_Wash_Bubble_pop_1();
	this.instance_34.parent = this;
	this.instance_34.setTransform(55,2.5,1,1,0,0,0,11,11);
	this.instance_34.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_33}]}).to({state:[{t:this.instance_34}]},30).to({state:[{t:this.instance_34}]},2).to({state:[]},2).wait(58));
	this.timeline.addTween(cjs.Tween.get(this.instance_33).to({_off:true,regX:11,regY:11,scaleX:1,scaleY:1},30).wait(62));

	// M_Wash_Bubble
	this.instance_35 = new lib.M_Wash_Bubble_1();
	this.instance_35.parent = this;
	this.instance_35.setTransform(54.9,24.5,0.157,0.157,0,0,0,11.2,11.2);
	this.instance_35.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_36 = new lib.M_Wash_Bubble_pop_1();
	this.instance_36.parent = this;
	this.instance_36.setTransform(54.9,24.5,1,1,0,0,0,11,11);
	this.instance_36.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_35}]}).to({state:[{t:this.instance_36}]},32).to({state:[{t:this.instance_36}]},2).to({state:[]},2).wait(56));
	this.timeline.addTween(cjs.Tween.get(this.instance_35).to({_off:true,regX:11,regY:11,scaleX:1,scaleY:1},32).wait(60));

	// M_Wash_Bubble
	this.instance_37 = new lib.M_Wash_Bubble_1();
	this.instance_37.parent = this;
	this.instance_37.setTransform(36,24.5,0.357,0.357,0,0,0,10.2,11.1);
	this.instance_37.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_38 = new lib.M_Wash_Bubble_pop_1();
	this.instance_38.parent = this;
	this.instance_38.setTransform(36,24.5,1,1,0,0,0,11,11);
	this.instance_38.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_37}]}).to({state:[{t:this.instance_38}]},30).to({state:[{t:this.instance_38}]},2).to({state:[]},2).wait(58));
	this.timeline.addTween(cjs.Tween.get(this.instance_37).to({_off:true,regX:11,regY:11,scaleX:1,scaleY:1},30).wait(62));

	// M_Wash_Bubble
	this.instance_39 = new lib.M_Wash_Bubble_1();
	this.instance_39.parent = this;
	this.instance_39.setTransform(22,13.5,0.165,0.165,0,0,0,10.9,11);
	this.instance_39.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get(this.instance_39).to({regY:10.9,scaleX:0.91,scaleY:0.91,x:18.6,y:13.3},22).to({regX:11,regY:11,scaleX:1,scaleY:1,x:22,y:13.5},2).wait(2).to({_off:true},2).wait(64));

	// M_Wash_Bubble
	this.instance_40 = new lib.M_Wash_Bubble_1();
	this.instance_40.parent = this;
	this.instance_40.setTransform(39.7,11,0.136,0.136,0,0,0,11.1,11.1);
	this.instance_40.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get(this.instance_40).to({regX:11,regY:11,scaleX:1,scaleY:1},22).wait(2).to({_off:true},2).wait(66));

	// M_Wash_Bubble
	this.instance_41 = new lib.M_Wash_Bubble_1();
	this.instance_41.parent = this;
	this.instance_41.setTransform(17.7,28,0.164,0.164,0,0,0,10.7,11);
	this.instance_41.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get(this.instance_41).to({regX:11,scaleX:1,scaleY:1},24).wait(2).to({_off:true},2).wait(64));

	// M_Wash_Bubble
	this.instance_42 = new lib.M_Wash_Bubble_1();
	this.instance_42.parent = this;
	this.instance_42.setTransform(11,2.5,0.088,0.088,0,0,0,10.8,10.8);
	this.instance_42.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_43 = new lib.M_Wash_Bubble_pop_1();
	this.instance_43.parent = this;
	this.instance_43.setTransform(11,2.5,1,1,0,0,0,11,11);
	this.instance_43.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_42}]}).to({state:[{t:this.instance_43}]},30).to({state:[{t:this.instance_43}]},2).to({state:[]},2).wait(58));
	this.timeline.addTween(cjs.Tween.get(this.instance_42).to({_off:true,regX:11,regY:11,scaleX:1,scaleY:1},30).wait(62));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-11.2,-37.9,114.4,94.8);


(lib.LionTorso_bubbles = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"wash":0,"wash_stop":90});

	// Layer 5
	this.instance = new lib.Bubbles_together();
	this.instance.parent = this;
	this.instance.setTransform(-65.6,-41.3,0.794,0.794,170,0,0,36.2,11.1);

	this.instance_1 = new lib.Bubbles_together();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-7.2,5,0.713,0.713,0,0,0,36,11);

	this.instance_2 = new lib.Bubbles_together();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-34.5,-31.3,1.094,1.094,51.8,0,0,35.9,11);

	this.instance_3 = new lib.Bubbles_together();
	this.instance_3.parent = this;
	this.instance_3.setTransform(10.9,-14.8,1.094,1.094,-173.2,0,0,35.9,11.1);

	this.instance_4 = new lib.Bubbles_together();
	this.instance_4.parent = this;
	this.instance_4.setTransform(67.3,-33.6,0.945,0.945,135,0,0,36,11);

	this.instance_5 = new lib.Bubbles_together();
	this.instance_5.parent = this;
	this.instance_5.setTransform(49.1,-45.1,1.094,1.094,-173.2,0,0,35.8,11);

	this.instance_6 = new lib.Bubbles_together();
	this.instance_6.parent = this;
	this.instance_6.setTransform(2.5,-38.6,0.713,0.713,0,0,0,36,11);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_6},{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]},1).to({state:[]},89).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = null;


(lib.LionTorso = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,dirty_stop:1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":100,"glowclean":101,"glowclean_loop":102,"final":103,"final_loop":104});

	// Layer 7
	this.instance = new lib.LionTorso0001();
	this.instance.parent = this;
	this.instance.setTransform(-125,-66.9,0.5,0.5);

	this.instance_1 = new lib.left_over_bubbles_few();
	this.instance_1.parent = this;
	this.instance_1.setTransform(46.4,-37.9,1,1,0,0,0,47.8,9.3);

	this.instance_2 = new lib.left_over_bubbles();
	this.instance_2.parent = this;
	this.instance_2.setTransform(3.7,-22.9,1,1,0,180,0,50.6,5.2);

	this.instance_3 = new lib.LionTorso0002();
	this.instance_3.parent = this;
	this.instance_3.setTransform(-125,-66.9,0.5,0.5);

	this.instance_4 = new lib.lion_backGlow();
	this.instance_4.parent = this;
	this.instance_4.setTransform(-7.4,-28.8,1.453,1.545,0,-2.9,178.3,110,13.6);

	this.glow = new lib.blueglowback();
	this.glow.parent = this;
	this.glow.setTransform(-7.4,-28.8,1.453,1.545,0,-2.9,178.3,110,13.6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_3},{t:this.instance_2},{t:this.instance_1}]},2).to({state:[{t:this.instance},{t:this.instance_4}]},2).to({state:[{t:this.instance_3}]},2).to({state:[{t:this.instance_3},{t:this.instance_2},{t:this.instance_1}]},7).to({state:[{t:this.instance_3},{t:this.instance_2},{t:this.instance_1}]},87).to({state:[{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.glow}]},1).to({state:[{t:this.instance_3}]},2).to({state:[]},2).wait(141));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-125,-66.9,258,142);


(lib.LionTail_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 3
	this.instance = new lib.LionTail();
	this.instance.parent = this;
	this.instance.setTransform(-36,-58.4,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// Layer 2
	this.instance_1 = new lib.LionTailEnd();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-22.8,60.1);
	this.instance_1.shadow = new cjs.Shadow("#000000",0,1,3);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1));

	// Tail
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#F0CF4A").s().p("AjSIUIgEgqQAAgeAkhLQAkhKgChPQgJilAAhXQAAinAfhwQAahfB5hWQB7hXAzAOQAzAPhpB0QhoB0gOAZQgIAPgVAfQgtBIAACPQAAA4AFB5QAEB5gFA5QgGA6gsBAQgsBBgfAYQgLAKgJAAQgOAAgIgYg");
	this.shape.setTransform(0,-0.7);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.LionTail_1, new cjs.Rectangle(-36,-58.4,63,146), null);


(lib.LionHindLeg_bubbles = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"wash":0,"wash_stop":90});

	// Layer 2
	this.instance = new lib.Bubbles_together();
	this.instance.parent = this;
	this.instance.setTransform(199,21.9,0.699,0.699,-30.8,0,0,35.6,10.6);

	this.instance_1 = new lib.Bubbles_together();
	this.instance_1.parent = this;
	this.instance_1.setTransform(158.8,9.2,0.699,0.699,-30.8,0,0,35.6,10.7);

	this.instance_2 = new lib.Bubbles_together();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-13,-2.2,0.699,0.699,29.4,0,0,35.6,10.9);

	this.instance_3 = new lib.Bubbles_together();
	this.instance_3.parent = this;
	this.instance_3.setTransform(-13.9,-17.6,0.699,0.699,-134.9,0,0,35.7,10.8);

	this.instance_4 = new lib.Bubbles_together();
	this.instance_4.parent = this;
	this.instance_4.setTransform(14.5,10.3,0.699,0.699,-0.4,0,0,35.6,10.9);

	this.instance_5 = new lib.Bubbles_together();
	this.instance_5.parent = this;
	this.instance_5.setTransform(9.2,-28.4,0.699,0.699,92.9,0,0,35.6,10.7);

	this.instance_6 = new lib.Bubbles_together();
	this.instance_6.parent = this;
	this.instance_6.setTransform(-12,-32.5,0.699,0.699,-115.7,0,0,35.6,10.8);

	this.instance_7 = new lib.Bubbles_together();
	this.instance_7.parent = this;
	this.instance_7.setTransform(-12,29.8,0.699,0.699,-30.8,0,0,35.6,10.7);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_7},{t:this.instance_6},{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]},1).to({state:[]},89).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = null;


(lib.LionHead_001_bubbles = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"wash":0,"wash_stop":90});

	// Cheeks
	this.instance = new lib.Bubbles_together();
	this.instance.parent = this;
	this.instance.setTransform(69.2,69.1,0.423,0.42,0,10.5,12.4,35.6,10.9);

	this.instance_1 = new lib.Bubbles_together();
	this.instance_1.parent = this;
	this.instance_1.setTransform(80.2,61.9,0.382,0.379,0,-169.5,-167.6,35.6,10.9);

	this.instance_2 = new lib.Bubbles_together();
	this.instance_2.parent = this;
	this.instance_2.setTransform(75.5,72.4,0.423,0.42,0,-134.1,-132.1,35.6,11);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_2},{t:this.instance_1},{t:this.instance}]},1).to({state:[]},89).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = null;


(lib.LionFrontLegBack_bubbles = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"wash":0,"wash_stop":90});

	// Layer 5
	this.instance = new lib.Bubbles_together();
	this.instance.parent = this;
	this.instance.setTransform(-198.1,63.8,0.689,0.689,-163.3,0,0,36,10.8);

	this.instance_1 = new lib.Bubbles_together();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-16.3,58.7,0.689,0.689,-79.9,0,0,36,10.8);

	this.instance_2 = new lib.Bubbles_together();
	this.instance_2.parent = this;
	this.instance_2.setTransform(6.9,60.7,0.712,0.712,-105,0,0,35.9,11);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_2},{t:this.instance_1},{t:this.instance}]},1).to({state:[]},89).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = null;


(lib.LionFrontLeg_bubbles = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"wash":0,"wash_stop":90});

	// Layer 5
	this.instance = new lib.Bubbles_together();
	this.instance.parent = this;
	this.instance.setTransform(11.6,-106.5,0.598,0.598,110.1,0,0,35.9,10.7);

	this.instance_1 = new lib.Bubbles_together();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-4.1,-115.6,0.598,0.598,131.8,0,0,35.3,10.5);

	this.instance_2 = new lib.Bubbles_together();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-12.5,-142.1,0.598,0.598,110.1,0,0,35.7,11);

	this.instance_3 = new lib.Bubbles_together();
	this.instance_3.parent = this;
	this.instance_3.setTransform(16.2,-137.5,0.735,0.735,162.6,0,0,35.8,10.8);

	this.instance_4 = new lib.Bubbles_together();
	this.instance_4.parent = this;
	this.instance_4.setTransform(8.3,-156.5,0.589,0.589,162.6,0,0,35.8,10.9);

	this.instance_5 = new lib.Bubbles_together();
	this.instance_5.parent = this;
	this.instance_5.setTransform(43.8,-147.2,0.503,0.503,47.9,0,0,35.8,10.8);

	this.instance_6 = new lib.Bubbles_together();
	this.instance_6.parent = this;
	this.instance_6.setTransform(34.3,-159.3,0.589,0.589,-159.9,0,0,35.9,11);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_6},{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]},1).to({state:[]},89).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = null;


(lib.water_drops_014 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.Running_drop();
	this.instance.parent = this;
	this.instance.setTransform(185.8,10.7,0.486,0.486,0,0,180,4.8,10.1);
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1).to({_off:false},0).to({_off:true},24).wait(8));

	// Layer 1
	this.instance_1 = new lib.Running_drop();
	this.instance_1.parent = this;
	this.instance_1.setTransform(174.5,47.7,0.486,0.486,0,0,180,4.7,10.1);
	this.instance_1._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(7).to({_off:false},0).to({_off:true},24).wait(2));

	// WET DROPS
	this.instance_2 = new lib.Running_drop();
	this.instance_2.parent = this;
	this.instance_2.setTransform(70,37,0.486,0.486,0,0,180,4.8,10.1);
	this.instance_2._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(4).to({_off:false},0).to({_off:true},24).wait(5));

	// WET DROPS
	this.instance_3 = new lib.Running_drop();
	this.instance_3.parent = this;
	this.instance_3.setTransform(20,71.3,0.486,0.486,0,0,180,4.7,10.1);
	this.instance_3._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_3).wait(1).to({_off:false},0).to({_off:true},24).wait(8));

	// WET DROPS
	this.instance_4 = new lib.Running_drop();
	this.instance_4.parent = this;
	this.instance_4.setTransform(42.4,57.4,0.486,0.486,0,0,0,4.8,10.1);
	this.instance_4._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_4).wait(6).to({_off:false},0).to({_off:true},24).wait(3));

	// WET DROPS
	this.instance_5 = new lib.Running_drop();
	this.instance_5.parent = this;
	this.instance_5.setTransform(214.7,42.7,0.486,0.486,0,0,0,4.8,10.1);
	this.instance_5._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_5).wait(3).to({_off:false},0).to({_off:true},24).wait(6));

	// WET DROPS
	this.instance_6 = new lib.Running_drop();
	this.instance_6.parent = this;
	this.instance_6.setTransform(132.4,67.1,0.486,0.486,0,0,0,4.8,10.1);

	this.timeline.addTween(cjs.Tween.get(this.instance_6).to({_off:true},24).wait(9));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(125.1,57.2,18,23);


(lib.lion_pawMud_002 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_loop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":260,"final":261,"final_loop":262});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(169,114,78,0.8)").s().p("AgfAyIgEACIgaAAQgDgJAHgIIAEgFIAAgIQgMgHgHgHIgJgDQgHgFgHgJIgCgDIACgrQAIgDAKACIAGABQAUAOAWAAQAGAAAQgEQAPgFALAAQAQAAAPAKQANAHAMAOQAUAWADANIgGACIgBgBIgEALQgGABgEACQgEgCgCAEIgZACQgDAHADAHIABAGQgOADgOAAQgYAAgagIg");
	this.shape.setTransform(31.9,36.6);

	this.instance = new lib.left_over_bubbles_few();
	this.instance.parent = this;
	this.instance.setTransform(11,18.7,0.552,0.552,-55.7,0,0,47.8,9.3);

	this.instance_1 = new lib.left_over_bubbles_sparse();
	this.instance_1.parent = this;
	this.instance_1.setTransform(20.9,31.2,1,1,-150,0,0,46.1,10);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape}]}).to({state:[{t:this.instance_1},{t:this.instance}]},2).to({state:[{t:this.shape}]},2).to({state:[]},2).to({state:[{t:this.instance_1},{t:this.instance}]},25).to({state:[]},230).to({state:[]},1).wait(40));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(22.2,30.8,19.6,11.6);


(lib.lion_pawMud_001 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_loop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":79,"glowclean":80,"glowclean_loop":81,"final":82,"final_loop":83});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(169,114,78,0.8)").s().p("AAADhQgrgOgEAAQhOAAgNgDQg+gOABg7QAAgSgEgmIgDgpIADg4QABgUgLgWIgKgYQABgFAFgOIAFgPQgCgKABgHQACgRAQABIAHABIgEgTQgEgNAAgIQADgMAGgLQALgYAPAAQAXAAAOAnQANAlADAAQAZAAAPAHQAQAIAAAOIAEAdQAAAKAEANQAQgDANAOQAJAMgBAJQABALABAKIABAOQABAYAWAAQALAAAOgEQANgBAYAQIAjAHQAiAFAMAIQATANASAVQAVAXAAANIAAABQAEAEAAAFIgDAIIgCAIIAAALIgCACIgWgEIgKAIIgEAYIAEAMQgBAFgFgBIgHAEIgJgBIgDgHQgZgPgigBIgCAAIgIAFQgEAIgBANIAAAHIADAEQARAFASABIgMAHQgYANgJgBQghABgugNgAhdixQgEgGAAgFQAAgcAZgDQAXgCAAATQAAAigcAAQgKAAgGgJg");
	this.shape.setTransform(28.7,40.3);

	this.instance = new lib.left_over_bubbles_few();
	this.instance.parent = this;
	this.instance.setTransform(19.1,34.9,0.838,0.838,-88.7,0,0,46,10.1);

	this.instance_1 = new lib.left_over_bubbles_sparse();
	this.instance_1.parent = this;
	this.instance_1.setTransform(34.5,48.1,1,1,0,0,0,46.1,10.1);

	this.instance_2 = new lib.lion_footGlow();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-63.6,46.3,1.25,1.25,0,2.4,-177.6,102.2,27.8);

	this.glow = new lib.blueglowpaws();
	this.glow.parent = this;
	this.glow.setTransform(-63.6,46.3,1.25,1.25,0,2.4,-177.6,102.2,27.8);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape}]}).to({state:[{t:this.instance_1},{t:this.instance}]},2).to({state:[{t:this.shape},{t:this.instance_2}]},2).to({state:[]},2).to({state:[{t:this.instance_1},{t:this.instance}]},7).to({state:[{t:this.instance_1},{t:this.instance}]},66).to({state:[{t:this.instance_1},{t:this.instance},{t:this.glow}]},1).to({state:[]},2).to({state:[]},181).wait(41));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(6.3,16.5,44.7,47.5);


(lib.lion_mouthMud_002_bubbles = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"mud":0,"soap":45,"clean":57});

	// timeline functions:
	this.frame_0 = function() {
		/* stop();*/
	}
	this.frame_45 = function() {
		/* stop();*/
	}
	this.frame_57 = function() {
		/* stop();*/
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(45).call(this.frame_45).wait(12).call(this.frame_57).wait(12));

	// Layer 5
	this.instance = new lib.Bubbles_together();
	this.instance.parent = this;
	this.instance.setTransform(23.3,22.2,0.702,0.689,0,-42.7,-53.9,36,10.7);

	this.instance_1 = new lib.Bubbles_together();
	this.instance_1.parent = this;
	this.instance_1.setTransform(21.7,7.8,0.633,0.621,0,-137.7,-148.9,36.1,10.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_1},{t:this.instance}]},1).to({state:[]},44).wait(24));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = null;


(lib.lion_mouthMud_001_bubbles = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"mud":0,"soap":45,"clean":57});

	// timeline functions:
	this.frame_0 = function() {
		/* stop();*/
	}
	this.frame_45 = function() {
		/* stop();*/
	}
	this.frame_57 = function() {
		/* stop();*/
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(45).call(this.frame_45).wait(12).call(this.frame_57).wait(12));

	// Layer 5
	this.instance = new lib.Bubbles_together();
	this.instance.parent = this;
	this.instance.setTransform(9.4,12.5,0.423,0.42,0,10.5,12.4,35.7,10.9);

	this.instance_1 = new lib.Bubbles_together();
	this.instance_1.parent = this;
	this.instance_1.setTransform(20.3,5.2,0.382,0.379,0,-169.5,-167.6,35.6,11);

	this.instance_2 = new lib.Bubbles_together();
	this.instance_2.parent = this;
	this.instance_2.setTransform(15.6,15.8,0.423,0.42,0,-134.1,-132.1,35.6,11);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_2},{t:this.instance_1},{t:this.instance}]},1).to({state:[]},44).wait(24));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = null;


(lib.lion_maneMud_001_bubbles = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"mud":0,"soap":45,"clean":57});

	// timeline functions:
	this.frame_0 = function() {
		/* stop();*/
	}
	this.frame_45 = function() {
		/* stop();*/
	}
	this.frame_57 = function() {
		/* stop();*/
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(45).call(this.frame_45).wait(12).call(this.frame_57).wait(12));

	// Layer 5
	this.instance = new lib.Bubbles_together();
	this.instance.parent = this;
	this.instance.setTransform(32.6,68.2,0.598,0.598,110.1,0,0,35.9,10.7);

	this.instance_1 = new lib.Bubbles_together();
	this.instance_1.parent = this;
	this.instance_1.setTransform(16.9,59.1,0.598,0.598,131.8,0,0,35.3,10.5);

	this.instance_2 = new lib.Bubbles_together();
	this.instance_2.parent = this;
	this.instance_2.setTransform(8.5,32.6,0.598,0.598,110.1,0,0,35.6,11);

	this.instance_3 = new lib.Bubbles_together();
	this.instance_3.parent = this;
	this.instance_3.setTransform(37.2,37.2,0.735,0.735,162.6,0,0,35.8,10.8);

	this.instance_4 = new lib.Bubbles_together();
	this.instance_4.parent = this;
	this.instance_4.setTransform(29.3,18.3,0.589,0.589,162.6,0,0,35.8,10.8);

	this.instance_5 = new lib.Bubbles_together();
	this.instance_5.parent = this;
	this.instance_5.setTransform(64.9,27.5,0.503,0.503,47.9,0,0,35.9,10.8);

	this.instance_6 = new lib.Bubbles_together();
	this.instance_6.parent = this;
	this.instance_6.setTransform(55.3,15.4,0.589,0.589,-159.9,0,0,35.9,10.9);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_6},{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]},1).to({state:[]},44).wait(24));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = null;


(lib.lion_legMud_002 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_loop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":260,"final":262,"final_loop":263});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(169,114,78,0.8)").s().p("AjqG5QgHgLAAgLQAAgbAigCQAhgDAAAiQAAAKgEAIQgJAQgVAAQgRAAgJgOgAiEGpQgJgNAAgQQAAgSAFgRQgOgGgLgSIgBAEQgHAcgbAAQgaAAgMgRQgJgMAAgPQAAgrAqgDQAMgBAJAEIgIgsIgGgLQgJAEgNAAQgsAAgZhSQAKhPgGhLIAAgDQgLhWgGhRQAAgEgFAAQAIg6gQgvQAPgJAZgEQA+gLAFhfQAFhgB0BWQByBWAohCQAnhCAaAzQAZA0AyACQAyABAVAgIAFAJQAMAcghAmIgJALQgfAmgRAtQgTAzApAFQARACAQALQgvA4gnA9QgHAMgMAEQgRAegYAYIgDAFIgJAEIgDAKQhCBGg5BNQgHAKgGALQgMAIgFAKIgIAVIgIAFIgGAOIgKAXQgNANgJASQgFAMgCAOQgDACgBADIgCAEQgJgEgGgJgAEdigIgVgFQgTgoAwgOQAkARghAmQgDAEgGAAIgCAAg");
	this.shape.setTransform(34.3,61.6);

	this.instance = new lib.left_over_bubbles_sparse();
	this.instance.parent = this;
	this.instance.setTransform(41,52.3,1,1,102.7,0,0,47.6,10);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape}]}).to({state:[{t:this.instance}]},2).to({state:[{t:this.shape}]},2).to({state:[]},2).to({state:[{t:this.instance}]},20).to({state:[]},236).to({state:[]},1).wait(39));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(3.1,16.2,62.5,90.9);


(lib.lion_legMud_001_bubbles = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"mud":0,"soap":45,"clean":57});

	// timeline functions:
	this.frame_0 = function() {
		/* stop();*/
	}
	this.frame_45 = function() {
		/* stop();*/
	}
	this.frame_57 = function() {
		/* stop();*/
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(45).call(this.frame_45).wait(12).call(this.frame_57).wait(12));

	// Layer 5
	this.instance = new lib.Bubbles_together();
	this.instance.parent = this;
	this.instance.setTransform(229.8,82.7,0.699,0.699,-30.8,0,0,35.6,10.6);

	this.instance_1 = new lib.Bubbles_together();
	this.instance_1.parent = this;
	this.instance_1.setTransform(189.6,70,0.699,0.699,-30.8,0,0,35.6,10.7);

	this.instance_2 = new lib.Bubbles_together();
	this.instance_2.parent = this;
	this.instance_2.setTransform(17.8,58.6,0.699,0.699,29.4,0,0,35.6,10.9);

	this.instance_3 = new lib.Bubbles_together();
	this.instance_3.parent = this;
	this.instance_3.setTransform(16.9,43.2,0.699,0.699,-134.9,0,0,35.7,10.8);

	this.instance_4 = new lib.Bubbles_together();
	this.instance_4.parent = this;
	this.instance_4.setTransform(45.3,71.1,0.699,0.699,-0.4,0,0,35.6,10.9);

	this.instance_5 = new lib.Bubbles_together();
	this.instance_5.parent = this;
	this.instance_5.setTransform(40,32.4,0.699,0.699,92.9,0,0,35.6,10.7);

	this.instance_6 = new lib.Bubbles_together();
	this.instance_6.parent = this;
	this.instance_6.setTransform(18.8,28.3,0.699,0.699,-115.7,0,0,35.6,10.8);

	this.instance_7 = new lib.Bubbles_together();
	this.instance_7.parent = this;
	this.instance_7.setTransform(18.8,90.6,0.699,0.699,-30.8,0,0,35.6,10.7);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_7},{t:this.instance_6},{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]},1).to({state:[]},44).wait(24));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = null;


(lib.lion_legMud_001 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_loop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":101,"glowclean":102,"glowclean_loop":103,"final":104,"final_loop":105});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(169,114,78,0.8)").s().p("AAGEoQgIgNAAgQQAAgSAEgRQgOgGgKgSIgBAEQgHAcgbAAQgagBgMgQQgKgMABgPQgBgrArgDQALgBAKAEIgJgtIgFgKQgKAEgMAAQgyAAgZhnQgPhBAAgyQAAgJACgFQgGgZgghWIABhJIAMAKIAHABQABAKAFADQACACAHgBIACAJQAGAFAFAGQAgAyAvAfIAJAHIAIAPIAQAIIA0BFIAPAbIBZBuQACAJAFAGQA0A4AgBHIgLAAQgGABgFgCQgNAJgMAEIgCAZQgKAqgnAAIgFgBIgGAMQgRAkgdgBQgdABgOgUgAhjEpQgHgLAAgMQAAgaAhgDQAigCAAAiQAAAJgEAJQgJAPgWAAQgQAAgJgNg");
	this.shape.setTransform(20.8,76);

	this.instance = new lib.left_over_bubbles_sparse();
	this.instance.parent = this;
	this.instance.setTransform(21.9,78.4,1,1,52,0,0,47.6,10);

	this.instance_1 = new lib.left_over_bubbles();
	this.instance_1.parent = this;
	this.instance_1.setTransform(10.8,86,0.807,0.807,-123.5,0,0,50.9,5.1);

	this.instance_2 = new lib.lion_legGlow();
	this.instance_2.parent = this;
	this.instance_2.setTransform(93.4,45.8,1.499,1.499,0,160.5,-19.5,-47.5,65.6);

	this.glow = new lib.blueglowlegs();
	this.glow.parent = this;
	this.glow.setTransform(93.4,45.8,1.499,1.499,0,160.5,-19.5,-47.5,65.6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape}]}).to({state:[{t:this.instance_1},{t:this.instance}]},2).to({state:[{t:this.shape},{t:this.instance_2}]},2).to({state:[]},2).to({state:[{t:this.instance_1},{t:this.instance}]},8).to({state:[{t:this.instance_1},{t:this.instance}]},87).to({state:[{t:this.instance_1},{t:this.instance},{t:this.glow}]},1).to({state:[]},2).to({state:[]},159).wait(41));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0.4,44.5,40.8,63.1);


(lib.legmudfront = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_loop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":260,"final":262,"final_loop":263});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(169,114,78,0.8)").s().p("AkdDXQAKhPgGhNIAAgDQgLhVgGhQQAAgFgFAAQAIg5gQgvQAPgJAZgFQApgHAQgtIAdgCIAYANQCdALCmgfIARgDQAPAHARAAQAyACAVAgIAFAIQAMAdghAmIgJAKQgfAngRAtQgTAzApAEQARACAQAMQghAmgcAqQgbAQgeAMQgCAOgQAFQglANgcAVIgRADQgFAMgNAJQhoBCiFA+IgHABQgsAAgZhSgAEdhfIgVgEQgTgoAwgPQAkASghAlQgDAFgGAAIgCgBg");
	this.shape.setTransform(34.3,55);

	this.instance = new lib.left_over_bubbles_sparse();
	this.instance.parent = this;
	this.instance.setTransform(41,52.3,1,1,102.7,0,0,47.6,10);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape}]}).to({state:[{t:this.instance}]},2).to({state:[{t:this.shape}]},2).to({state:[]},2).to({state:[{t:this.instance}]},54).to({state:[]},202).to({state:[]},1).wait(39));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(3.1,25.4,62.5,59.4);


(lib.legmudback = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_loop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":260,"final":262,"final_loop":263});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(169,114,78,0.8)").s().p("AjCGKIAEgGIgEAIgAi3FzIgFAMQgCgOABgJIAAgDIAAgCIACgFQACgJAEgIIAIgSIAAAAQgEgIAFgDQAAAAABAAQAAAAAAgBQABAAAAgBQAAAAABgBIAAgXIAAgVIAHgLIgEgJIADgRQAKhGAFhLIAGgDQAAgBABAAQAAAAAAgBQABAAAAgBQAAAAAAgBIAAgDIACgPIAbiKIgEg3IAFgNIgEgKIAHgVIAHgKQgBgFAAgGQAGgugDguIAFgNIgGgRQAkADASgfQAohCAYAzQAZA0AyACQAyABAWAgIAEAJQAMAdghAlIgJALQgfAmgRAtQgSAzAoAFQARACAQALQgvA3gmA+QgIAMgLAEQgIAOgKANQgCAQgHAQIgEAKQgdAVgXAfIgJADQAVArgWA0IgDAKQgfAVgWAfIg2AWQgOgDgJgOgACph9IgWgFQgTgoAxgOQAkARghAmQgEAEgFAAIgCAAg");
	this.shape.setTransform(45.9,58.1);

	this.instance = new lib.left_over_bubbles_sparse();
	this.instance.parent = this;
	this.instance.setTransform(41,52.3,1,1,102.7,0,0,47.6,10);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape}]}).to({state:[{t:this.instance}]},2).to({state:[{t:this.shape}]},2).to({state:[]},2).to({state:[{t:this.instance}]},33).to({state:[]},224).to({state:[]},1).wait(38));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(26.4,18.5,39.1,79.3);


(lib.LionHindLegBack = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_stop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":209});

	// Layer 7
	this.backfootbackmud = new lib.lion_pawMud_002();
	this.backfootbackmud.parent = this;
	this.backfootbackmud.setTransform(-11.6,60.4,1,1,0,0,0,20.9,29);

	this.hindlegbackmud = new lib.legmudback();
	this.hindlegbackmud.parent = this;
	this.hindlegbackmud.setTransform(3.6,17.3,0.749,0.749,-151.7,0,0,33.9,61.4);

	this.instance = new lib.LionHindLegBack0004();
	this.instance.parent = this;
	this.instance.setTransform(-37.7,-76.2,0.5,0.5);

	this.instance_1 = new lib.LionHindLegBack0001();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-37.7,-76.2,0.5,0.5);

	this.instance_2 = new lib.LionHindLegBack0002();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-37.7,-76.2,0.5,0.5);

	this.instance_3 = new lib.LionHindLegBack0003();
	this.instance_3.parent = this;
	this.instance_3.setTransform(-37.7,-76.2,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance},{t:this.hindlegbackmud},{t:this.backfootbackmud}]}).to({state:[{t:this.instance}]},2).to({state:[{t:this.instance_1}]},2).to({state:[{t:this.instance}]},2).to({state:[{t:this.instance_2}]},2).to({state:[{t:this.instance_3}]},2).wait(200));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-37.7,-76.2,79,160.9);


(lib.LionHindLeg = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_stop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":209,"final":210,"final_loop":211});

	// Layer 5
	this.backfootmud = new lib.lion_pawMud_004();
	this.backfootmud.parent = this;
	this.backfootmud.setTransform(1.3,80.4,1,1,0,0,0,28.7,40.2);

	this.hindlegmud = new lib.lion_legMud_002();
	this.hindlegmud.parent = this;
	this.hindlegmud.setTransform(0,0.1,1,1,0,0,0,33.5,61.6);

	this.instance = new lib.LionHindLeg0004();
	this.instance.parent = this;
	this.instance.setTransform(-39.6,-81.1,0.5,0.5);

	this.instance_1 = new lib.LionHindLeg0001();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-39.6,-81.1,0.5,0.5);

	this.instance_2 = new lib.LionHindLeg0002();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-39.6,-81.1,0.5,0.5);

	this.instance_3 = new lib.LionHindLeg0003();
	this.instance_3.parent = this;
	this.instance_3.setTransform(-39.6,-81.1,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance},{t:this.hindlegmud},{t:this.backfootmud}]}).to({state:[{t:this.instance}]},2).to({state:[{t:this.instance_1}]},2).to({state:[{t:this.instance}]},2).to({state:[{t:this.instance_2}]},2).to({state:[{t:this.instance_3}]},2).to({state:[]},200).wait(2));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-39.6,-81.1,84,185);


(lib.LionFrontLegBack = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_stop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":209});

	// Layer 7
	this.frontfootbackmud = new lib.footmudfront();
	this.frontfootbackmud.parent = this;
	this.frontfootbackmud.setTransform(13.8,55.8,0.6,0.6,0,0,0,28.5,40.4);

	this.frontlegbackmud = new lib.legmudfront();
	this.frontlegbackmud.parent = this;
	this.frontlegbackmud.setTransform(-14.9,6.7,0.6,0.6,105,0,0,34.1,61.6);

	this.instance = new lib.LionFrontLegBack0004();
	this.instance.parent = this;
	this.instance.setTransform(-27.4,-71.5,0.5,0.5);

	this.instance_1 = new lib.LionFrontLegBack0001();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-27.4,-71.5,0.5,0.5);

	this.instance_2 = new lib.LionFrontLegBack0002();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-27.4,-71.5,0.5,0.5);

	this.instance_3 = new lib.LionFrontLegBack0003();
	this.instance_3.parent = this;
	this.instance_3.setTransform(-27.4,-71.5,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance},{t:this.frontlegbackmud},{t:this.frontfootbackmud}]}).to({state:[{t:this.instance}]},2).to({state:[{t:this.instance_1}]},2).to({state:[{t:this.instance}]},2).to({state:[{t:this.instance_2}]},2).to({state:[{t:this.instance_3}]},2).wait(200));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-37.9,-71.5,73.6,149);


(lib.LionFrontLeg = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_stop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":209});

	// Layer 6
	this.instance = new lib.lion_legMud_001_bubbles();
	this.instance.parent = this;
	this.instance.setTransform(-206.6,-55.5,1,1,-40,0,0,-0.1,0);
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(6).to({_off:false},0).wait(204));

	// Layer 7
	this.frontlegmud = new lib.lion_legMud_001();
	this.frontlegmud.parent = this;
	this.frontlegmud.setTransform(-31.7,7,0.8,0.8,-158.1,0,0,33.4,61.5);

	this.frontfootmud = new lib.lion_pawMud_001();
	this.frontfootmud.parent = this;
	this.frontfootmud.setTransform(15.1,59.3,1,1,0,0,0,28.7,40.2);

	this.instance_1 = new lib.LionFrontLeg0004();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-31.7,-79.5,0.5,0.5);

	this.instance_2 = new lib.lion_legGlow();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-80.3,-2.9,1.259,1.283,0,2.9,-178.4,-47.2,65.3);

	this.instance_3 = new lib.LionFrontLeg0001();
	this.instance_3.parent = this;
	this.instance_3.setTransform(-31.7,-79.5,0.5,0.5);

	this.instance_4 = new lib.LionFrontLeg0002();
	this.instance_4.parent = this;
	this.instance_4.setTransform(-31.7,-79.5,0.5,0.5);

	this.instance_5 = new lib.LionFrontLeg0003();
	this.instance_5.parent = this;
	this.instance_5.setTransform(-31.7,-79.5,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1},{t:this.frontfootmud},{t:this.frontlegmud}]}).to({state:[{t:this.instance_1}]},2).to({state:[{t:this.instance_3},{t:this.instance_2}]},1).to({state:[{t:this.instance_1}]},2).to({state:[{t:this.instance_4}]},2).to({state:[{t:this.instance_5}]},2).to({state:[]},200).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-59.6,-79.5,108.9,173);


(lib.LionCheekFront_bubbles = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.lion_mouthMud_001_bubbles();
	this.instance.parent = this;
	this.instance.setTransform(14.2,17.4,1,1,0,0,0,14.2,10.8);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.LionCheekFront_bubbles, null, null);


(lib.mouthmud5 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_loop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":260,"glowclean":261,"glowclean_loop":262,"final":263,"final_loop":264});

	// Layer 5
	this.instance = new lib.lion_mouthMud_001_bubbles();
	this.instance.parent = this;
	this.instance.setTransform(15,12.4);
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(6).to({_off:false},0).to({_off:true},254).wait(44));

	// Layer 1
	this.instance_1 = new lib.mouthmudbottom();
	this.instance_1.parent = this;
	this.instance_1.setTransform(10.9,17.8,0.6,0.6,0,0,0,21.9,11.9);

	this.instance_2 = new lib.mouthmudbottom();
	this.instance_2.parent = this;
	this.instance_2.setTransform(14.2,19.4,0.6,0.6,0,0,0,21.9,11.9);

	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(169,114,78,0.8)").s().p("AD2CFIABgFIAAAPIgBgKgAhMCJQglAAgWgKQgdgNgRgCQgKgBgMgJIAAgDIgLgDQgLgBgLgJQAAgFgCgFIgBgCIABgFQACgXgCgVIgEgEIgBgHQgGgRAFgRIADADIADgFIAFAAIAAAAQAEABACgCIABgBQAFgGABgGQACgHgBgIIAGgKIAKgGIAQACIAEAEIAQAEIAFgIIAAgHIABAAQADgGAHACIACAAQAGAAADAEQAEAEAIABIAHgRQALgBAFAEQAGAGADAIIAGACIAFAEQAHAKANAEIAVgIIAHgKQAEgKAHgFIABgCQAEgLAMgKIABAAIAFgEIgGAEIgBgBIALgKIAPgcIADACIAAABIADAAQALAAAHAFIAFAEIABgEIAAgBIABABIALARIAEADIABgEIAAgBIABABIAWAgIgEAHIAFAFIAHAKIABACIAAAQQABAHgDAHIACAGIgJASIAAAAIAAACIAAACQgEAFgEAIQgCAEgDAEIgEAHIgBACIgXAPIgGAOQgIARgPASIgQAQIAAACQggAcgoABIgEAAg");
	this.shape.setTransform(23.8,8.5);

	this.instance_3 = new lib.left_over_bubbles();
	this.instance_3.parent = this;
	this.instance_3.setTransform(13.2,12.9,0.389,0.389,-169.7,0,0,50.6,5);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("rgba(169,114,78,0.8)").s().p("AguBiQgdgNgRgCQgNgCgQgOQgLgLgDgIQgHgIgDgTQAAgKADgHQAEgOANAAIADAAQACgGAEgDQAHgGASgBQACgLAGgRQAMggATAAQANAAAPANQAHAGADAFIACgKQAFgQAMAAQAOAAAEAFIALAJQAAgHAJgMQAMgOARAAQARAAAPARIABABIACAAQALAAAIAJIABgFIATAhIgFAJQADAXgDALIgFAMQgCALgGAMQgIARgPASQgIAJgIAHIgBACQgiAdgqAAQgkAAgWgKg");
	this.shape_1.setTransform(14.6,10.8);

	this.glow = new lib.blueglowmouth();
	this.glow.parent = this;
	this.glow.setTransform(14.5,9.8,1,1,0,0,0,16.3,16.4);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape},{t:this.instance_2},{t:this.instance_1,p:{x:10.9,y:17.8}}]}).to({state:[{t:this.instance_3}]},2).to({state:[{t:this.shape_1},{t:this.instance_1,p:{x:14.2,y:19.4}}]},2).to({state:[]},2).to({state:[{t:this.instance_3}]},53).to({state:[{t:this.instance_3},{t:this.glow}]},202).to({state:[]},2).to({state:[]},1).wait(40));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-0.9,-5.8,49.5,32.4);


(lib.mouthmud4 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_loop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":260,"glowclean":261,"glowclean_loop":262,"final":263,"final_loop":264});

	// Layer 5
	this.instance = new lib.lion_mouthMud_001_bubbles();
	this.instance.parent = this;
	this.instance.setTransform(15,12.4);
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(6).to({_off:false},0).to({_off:true},254).wait(44));

	// Layer 1
	this.instance_1 = new lib.mouthmudbottom();
	this.instance_1.parent = this;
	this.instance_1.setTransform(14.2,19.4,0.6,0.6,0,0,0,21.9,11.9);

	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(169,114,78,0.8)").s().p("AEDCFIACgFIgBAPIgBgKgAh6B/QgcgNgRgCQgLgBgLgJQAAgGgCgFQgKgVgEgUIAAAAIgCgCQgRgHgMgOQgGgEgGgGQgIgSgEgWIATgKIACgEQAFgCAGgBQAJgCAGgEIAEgHQAAgGABgGIAFgPIABgCIABgBIAAAAQAFABACgFQABgFAEgCIATAHIACAEQAGAIAJAEIACgJIANgQIAMAAIAHAGIABgDIACADQADADAEAAIAMgFIAEgHIAbgBIAAABIAEgEIABABIABgEIABgCIAAABIAGAIIAIAFIACAHIABgDIABgBIAEAGIAAADIAOAAIAKgMQAIgEAGgGIANgKIAPgcIADACIABABIADAAQAKAAAIAFIAEAEIABgEIAAgBIABABIAMARIAEADIABgEIAAgBIABABIAWAgIgFAHIAFAFIAIAKIABACIAAAQQAAAHgDAHIADAGIgJASIAAAAIAAACIAAACQgFAFgDAIQgCAEgEAEIgEAHIAAACIgYAPIgGAOQgIARgPASIgPAQIgCACQggAdgqAAQglAAgXgKgAgthiIABABIgCABIABgCgAhHhxIAGAEIgCACIgCABg");
	this.shape.setTransform(22.4,8.5);

	this.instance_2 = new lib.left_over_bubbles();
	this.instance_2.parent = this;
	this.instance_2.setTransform(13.2,12.9,0.389,0.389,-169.7,0,0,50.6,5);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("rgba(169,114,78,0.8)").s().p("AguBiQgdgNgRgCQgNgCgQgOQgLgLgDgIQgHgIgDgTQAAgKADgHQAEgOANAAIADAAQACgGAEgDQAHgGASgBQACgLAGgRQAMggATAAQANAAAPANQAHAGADAFIACgKQAFgQAMAAQAOAAAEAFIALAJQAAgHAJgMQAMgOARAAQARAAAPARIABABIACAAQALAAAIAJIABgFIATAhIgFAJQADAXgDALIgFAMQgCALgGAMQgIARgPASQgIAJgIAHIgBACQgiAdgqAAQgkAAgWgKg");
	this.shape_1.setTransform(14.6,10.8);

	this.glow = new lib.blueglowmouth();
	this.glow.parent = this;
	this.glow.setTransform(14.5,5.1,1,1,0,0,0,16.3,16.4);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape},{t:this.instance_1}]}).to({state:[{t:this.instance_2}]},2).to({state:[{t:this.shape_1},{t:this.instance_1}]},2).to({state:[]},2).to({state:[{t:this.instance_2}]},53).to({state:[{t:this.instance_2},{t:this.glow}]},202).to({state:[]},2).to({state:[]},1).wait(40));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-3.6,-5.8,52.1,32.4);


(lib.mouthmud3 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_loop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":260,"glowclean":261,"glowclean_loop":262,"final":263,"final_loop":264});

	// Layer 5
	this.instance = new lib.lion_mouthMud_001_bubbles();
	this.instance.parent = this;
	this.instance.setTransform(15,12.4);
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(6).to({_off:false},0).to({_off:true},254).wait(44));

	// Layer 1
	this.instance_1 = new lib.mouthmudbottom();
	this.instance_1.parent = this;
	this.instance_1.setTransform(14.2,19.4,0.6,0.6,0,0,0,21.9,11.9);

	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(169,114,78,0.8)").s().p("AgpB1QgcgNgRgDQgLgBgLgJQAAgFgCgFQgKgWgEgTIgCgCQgggNgLglIADABIAAAAIAAAAIgDgCIAagOIACgFQAGgBAGgBQAIgDAHgEIAEgGQgBgHACgFIAFgPIABgCIAAgBQAGABABgFQABgFAEgDIATAIIADADQAGAJAJAEIABgJIAOgQIAMAAIAGAGIABgDIADACQACAEAFAAIAKgFIAEgHIAbgCIgBgGIAFADIgCADIAAAAIACgCIACAAIABgDIABgBIAGAIIAHAEIACAIIAKAEQAFAAABgCQANgMAIgNIAAgKIAEgEIAFgIQALAEAKAKIABABIADgBQANAAAJAKIABgFIAXAhIgFAJIAAACIACAAIAAACIACAIIgDAKIgBAGIgBAAQgGASgLASIgBAEIgBAGIgEAMQgCAMgHAMQgIAQgPATQgHAJgIAHIgCACQghAdgqAAQgkAAgXgKgAAfhfIAAACIACgCgAiqgNIABAAIAAABIgBgBgAipgMIAAAAgACqg1IABgFIAAAPIgBgKgACqg1IAAAAgAAnhnIAAABIgBACIABgDg");
	this.shape.setTransform(14,9);

	this.instance_2 = new lib.left_over_bubbles();
	this.instance_2.parent = this;
	this.instance_2.setTransform(13.2,12.9,0.389,0.389,-169.7,0,0,50.6,5);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("rgba(169,114,78,0.8)").s().p("AguBiQgdgNgRgCQgNgCgQgOQgLgLgDgIQgHgIgDgTQAAgKADgHQAEgOANAAIADAAQACgGAEgDQAHgGASgBQACgLAGgRQAMggATAAQANAAAPANQAHAGADAFIACgKQAFgQAMAAQAOAAAEAFIALAJQAAgHAJgMQAMgOARAAQARAAAPARIABABIACAAQALAAAIAJIABgFIATAhIgFAJQADAXgDALIgFAMQgCALgGAMQgIARgPASQgIAJgIAHIgBACQgiAdgqAAQgkAAgWgKg");
	this.shape_1.setTransform(14.6,10.8);

	this.glow = new lib.blueglowmouth();
	this.glow.parent = this;
	this.glow.setTransform(14.5,9.8,1,1,0,0,0,16.3,16.4);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape},{t:this.instance_1}]}).to({state:[{t:this.instance_2}]},2).to({state:[{t:this.shape_1},{t:this.instance_1}]},2).to({state:[]},2).to({state:[{t:this.instance_2}]},53).to({state:[{t:this.glow}]},202).to({state:[]},2).wait(41));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-3.1,-3.7,34.3,30.4);


(lib.mouthmud2 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_loop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":260,"glowclean":261,"glowclean_loop":262,"final":263,"final_loop":264});

	// Layer 5
	this.instance = new lib.lion_mouthMud_001_bubbles();
	this.instance.parent = this;
	this.instance.setTransform(15,12.4);
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(6).to({_off:false},0).to({_off:true},254).wait(44));

	// Layer 1
	this.instance_1 = new lib.mouthmudbottom();
	this.instance_1.parent = this;
	this.instance_1.setTransform(14.2,19.4,0.6,0.6,0,0,0,21.9,11.9);

	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(169,114,78,0.8)").s().p("AguBiQgdgNgRgCQgNgCgQgOQgLgLgDgIQgHgIgDgTQAAgKADgHQAEgOANAAIADAAQACgGAEgDQAHgGASgBQACgLAGgRQAMggATAAQANAAAPANQAHAGADAFIACgKQAFgQAMAAQAOAAAEAFIALAJQAAgHAJgMQAMgOARAAQARAAAPARIABABIACAAQALAAAIAJIABgFIATAhIgFAJQADAXgDALIgFAMQgCALgGAMQgIARgPASQgIAJgIAHIgBACQgiAdgqAAQgkAAgWgKg");
	this.shape.setTransform(14.6,10.8);

	this.instance_2 = new lib.left_over_bubbles();
	this.instance_2.parent = this;
	this.instance_2.setTransform(13.2,12.9,0.389,0.389,-169.7,0,0,50.6,5);

	this.glow = new lib.blueglowmouth();
	this.glow.parent = this;
	this.glow.setTransform(14.5,9.8,1,1,0,0,0,16.3,16.4);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape},{t:this.instance_1}]}).to({state:[{t:this.instance_2}]},2).to({state:[{t:this.shape},{t:this.instance_1}]},2).to({state:[]},2).to({state:[{t:this.instance_2}]},53).to({state:[{t:this.instance_2},{t:this.glow}]},202).to({state:[]},2).to({state:[]},1).wait(40));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,29.2,26.7);


(lib.manemud3 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_loop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":260,"glowclean":261,"glowclean_loop":262,"final":263,"final_loop":264});

	// Layer 5
	this.instance = new lib.lion_maneMud_001_bubbles();
	this.instance.parent = this;
	this.instance.setTransform(18,33.7);
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(6).to({_off:false},0).to({_off:true},254).wait(44));

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(169,114,78,0.902)").s().p("AkSF4QgjgDgLgZQgDgdgCgHQgsgBgUgUQADgHAAgKQABgdALgWIgDgDIAFgBIAEgNIATgNQAUgQAQgSIAAgcIgEgMIgrgZIgUgjIAAgUQgDghALgaIAHgFIAmhdIAEgFIAAgFQACgkAGgkQAFgDAEgGQAIgKANgEIAPgUIAIgCQA5guBGgOIALgLQAPgQAOgVIAOgJIABgCIAFgBIAAACQAGgBAAAFIANADIAGACQAGADAHgCQAMgHAQgGQAJgBAJgDIAFgFIAFAAQAFAFAIACIACACIAFAGIAFgBIAFgBQAQAHAMAKQALACALgDQAIgCACgFIAPgFIAcAAQAPgBAMACQAOAEANAHIAGAGQgCAMAEAJQAEAIAEAGIAOAKQAGgDAKAAQAfADAhAHIADADQAcALAYAVIgCgFQAHABACgGIAMAPIgKARIgWAEIgCgBIgCAGIAAgBIgDADIg5gDIgDggIgKgIIgOAAIgPAIIgHAJQgDAEAAAJQgMABgLACIgPgZIgFAAQgIgCgHAEIgCAGIgOAEIAEADIgKgBQgbgagugDQgHgBgKABQgBAMADAKIgCAAIAAgDIAAAAIgPAJIgLAFIgKgDQgKgEgHAEIAAgBQgDgFgHACIgLAOIgBABIgvgBIADAPIAUAKIgDACIgCAAIgBgBQgIgFgBAFIAAABIgFAAIgNAIIgIAPIgBABQgDgPgIgPIgCgEIgHgHIgIAGQgagRgggKIgDAAQgPgBgPgFIgaALIgHALIgBAFQgFABgBAFQgCAFgFAFIgGgCIgBACIgHANIAAAKIgDADIAAAQQABAYAEAWIAEAEQgBAKACAGQAJARAMAMIAJAJIAEAGIAHACIABAEIAKAGIANAHIAIgBIgBAEQgBAAgBAAQAAAAgBAAQAAAAgBABQAAAAAAAAIgDABIABABIAHACIgJAKIAAAdIAEAEQACAHAHAAIAAABIAEAHIgBALIgKAPIAAAlIAWAFIABgBIAAACIACAIIgGAOIgCAHIgHAIQgHAQgDAMQgCAHgBAHIAcAAIAEgHIALgJIAFASIgGADQgCAHgBALIgBARIAYgEIgBAYIgGAKIgHADIgDA3IARAFIAEgEQAFgHAJABQAJAEgEANQgBAKADAFQAOAIATACIAAACQgaAPgqACQgNABgMgMIgBAEIgEgTQgUADgYgCQgOgBgIgNIgCAEQgQAugiAAIgDAAgACbkEIABACIABgCIgCAAgAg+lCIABAAIgBgBIgCAAIACABgAi5gmIAHgEIgCAHg");
	this.shape.setTransform(55.9,42.9);

	this.instance_1 = new lib.lion_maneGlow();
	this.instance_1.parent = this;
	this.instance_1.setTransform(40.9,79.2,1.08,1.1,0,0,180,52.6,66.5);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("rgba(169,114,78,0.902)").s().p("AjOFkQgGgcgDgHQgwACgUgWQgLgNAAgRQAAggAWgkQAWgkAAgDIgCgUQgWgKgXgVQgtgmAAgXQAAgjAIgmQgBgIACgMQAGghAHgJIADgDIADgQIgHgUQgHgSAAgJQAAgiAOgXQAMgWARABIAMgQQAYgaAdgRQANgHALgEQAJgPAFgMQAkhTBeAmQARAHAQAKIAJACIAEABIATgFQAqgKAcAIQAaAIAFAVIAKAOIADAHIAGgBIAQABQANgOAZAGQAXAGALANQAwAOAeAfQAXAYAJAZIAEAOQAFADADAEQghgNgegJQAEAAAAgJIAAgJIgGgBQgOgDgDAJIgeAKQgSACgRALIABgLIgEgIQgBgFgIAAIgPAMIgKAKIgDAHQgGAMgJAGIgHgQQgGgGgCAFIgCAFIgBAAQgIAKAAAPIgVgBQABgUgFgWIgCgEQgSgggcgbIgCgCQgOgHgLgMIgagBIgMAGIgDAFQgFgBgFAEQgDADgIADIgGAKIgIAIIgIAUIgLAMIgBAJIgEACIgDAQQgEAYAAAXIADAFQgDAJACAGQAGAYAPATIACAHIAHADIABAHIAWAQIgJgIQAJgDALgBIgIAPIgEAAIgCABIgBABIAAACQgKABgGAHIgIAJIgCAOIADASQADAagMARIgDAQQgJA1ALAmQACAEAGABQAFABgBAEIgGA6IAEAJIACAHIACAAQADgCAEgGQAIgLAKgBIgCAMQgJArANAkIAAgCQAIgUATgJQgGAKgBAKIgDAWQgaANgqAAQgPAAgKgNQgMA2gmAAQgjAAgMgagAB1icIAFgHIgBAHg");
	this.shape_1.setTransform(40.1,44.3);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape}]}).to({state:[]},2).to({state:[{t:this.shape_1},{t:this.instance_1}]},2).to({state:[]},2).to({state:[]},256).wait(42));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(16.9,5.3,78,75.2);


(lib.manemud2 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_loop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":260,"glowclean":261,"glowclean_loop":262,"final":263,"final_loop":264});

	// Layer 5
	this.instance = new lib.lion_maneMud_001_bubbles();
	this.instance.parent = this;
	this.instance.setTransform(18,33.7);
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(6).to({_off:false},0).to({_off:true},254).wait(44));

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(169,114,78,0.902)").s().p("AkkFcQgGgcgDgHQgsABgUgSQACgHAAgKQgDg2AlgfQAMgBAFgIIADgGIAAgKQAFgEAGgJQACgEAAgIQgEgLgIgHQgRgOgVgKQgDgGgGgGIgOgNQgEgMgCgLQgBgQAAgQIAPgiQgCgJADgFQAlhHgBhOQAFgEADgIQAPgmAjgHQACgKAKgGQAJgFAEgHQAJgDAJgFQAUgLAOgLIAKAAIAegRIAAgDQADgLAHgKIAKAGIAPgbIAKgJIACABIAGACIAEABIAUgFQAqgKAcAIIAHADIAAgMIAWANQAEACAHgCIAAADQAFAAAAAFIASAJQAFADAHAAQAOgFAQgCQAKABAKgBIAKgIIACAAIABADIAKANIAEAHIAFAAIAQAAQANgOAZAGQAXAGALANQATAFAQAJQATAJAPAOIAIAAQAZAMASATIAOAQIg0AKIgDgCQADAEABAGIgogCIgCADQgUAFgTACIAAACIAEAOQAFADADADQgggNgfgIIABgBQgRgBgRgEIABgCIAAgBIgRAGQgSACgRALIABgLIgEgIQgBgFgIAAIgPAMIgKAKIgDAHQgGAMgJAGIgHgQQgGgGgCAFIgCAFIgBAAQgIAJAAAQIgVgBQABgUgFgWIgCgEQgRgggcgbIgCgCQgOgHgLgMIgbgBIgMAGIgDAFQgFgBgFAEQgDADgIADIgGAKIgIAIIgIAUIgLAMIgBAJIgEACIgDAQQgEAYAAAXIADAFQgDAJACAGQAFASAJAPIAHAKIACAHIAHADIAAADIAJAJIAAABIAOAKIgJgIQAJgDALgBIgIAPIgEAAIgCABIABABIAXAMIgJgGQAIgFALgCIgGAPIgEABIgCACIAAABIAAABQgKADgFAIIgHAKIABANIAFASQAGAagJASIgBAQQgCA3AQAjQAEAEAGAAQAEABAAAEIACA6IAGAJIACAGIACAAQADgCADgHQAGgMAKgCIAAALQgDAtASAhIAAgCQAEgVASgLQgEALAAAKIAAAWQgYARgqAFQgOACgMgMIAAAFIgHgTQgSAEgYAAQgOAAgKgNIgBAEQgOAygkAAQgjAAgMgagAApk7IACAAIgBAAIgBgBIAAABg");
	this.shape.setTransform(51.5,42.4,1,1,-11.2);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("rgba(169,114,78,0.902)").s().p("ABWBqIAFgHIgBAIgAhXg9IgDgGIAKABIgFAHgAA8hqIAEABQgBADgEABIABgFg");
	this.shape_1.setTransform(43.3,17.9);

	this.instance_1 = new lib.lion_maneGlow();
	this.instance_1.parent = this;
	this.instance_1.setTransform(40.9,79.2,1.08,1.1,0,0,180,52.6,66.5);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("rgba(169,114,78,0.902)").s().p("AjOFkQgGgcgDgHQgwACgUgWQgLgNAAgRQAAggAWgkQAWgkAAgDIgCgUQgWgKgXgVQgtgmAAgXQAAgjAIgmQgBgIACgMQAGghAHgJIADgDIADgQIgHgUQgHgSAAgJQAAgiAOgXQAMgWARABIAMgQQAYgaAdgRQANgHALgEQAJgPAFgMQAkhTBeAmQARAHAQAKIAJACIAEABIATgFQAqgKAcAIQAaAIAFAVIAKAOIADAHIAGgBIAQABQANgOAZAGQAXAGALANQAwAOAeAfQAXAYAJAZIAEAOQAFADADAEQghgNgegJQAEAAAAgJIAAgJIgGgBQgOgDgDAJIgeAKQgSACgRALIABgLIgEgIQgBgFgIAAIgPAMIgKAKIgDAHQgGAMgJAGIgHgQQgGgGgCAFIgCAFIgBAAQgIAKAAAPIgVgBQABgUgFgWIgCgEQgSgggcgbIgCgCQgOgHgLgMIgagBIgMAGIgDAFQgFgBgFAEQgDADgIADIgGAKIgIAIIgIAUIgLAMIgBAJIgEACIgDAQQgEAYAAAXIADAFQgDAJACAGQAGAYAPATIACAHIAHADIABAHIAWAQIgJgIQAJgDALgBIgIAPIgEAAIgCABIgBABIAAACQgKABgGAHIgIAJIgCAOIADASQADAagMARIgDAQQgJA1ALAmQACAEAGABQAFABgBAEIgGA6IAEAJIACAHIACAAQADgCAEgGQAIgLAKgBIgCAMQgJArANAkIAAgCQAIgUATgJQgGAKgBAKIgDAWQgaANgqAAQgPAAgKgNQgMA2gmAAQgjAAgMgagAB1icIAFgHIgBAHg");
	this.shape_2.setTransform(40.1,44.3);

	this.glow = new lib.blueglowmane();
	this.glow.parent = this;
	this.glow.setTransform(44.1,79.1,0.8,1.1,0,0,180,52.6,66.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_1},{t:this.shape}]}).to({state:[]},2).to({state:[{t:this.shape_2},{t:this.instance_1}]},2).to({state:[]},2).to({state:[{t:this.glow}]},255).to({state:[]},2).to({state:[]},1).wait(40));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(15,4.8,69,79.2);


(lib.lion_mouthGlow = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.LionCheekFront_bubbles();
	this.instance.parent = this;
	this.instance.setTransform(16.3,13,1.181,1.014,0,1.5,-178.5,13.8,12.8);
	this.instance.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,5);

	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFF00").s().p("AAEDDQgugCgqgYIAAgBQgggSgVgdQgJgNgHgPQgpgjAChGIAAgBQABg5AagqIABAAQAzhVCEAEQBzADAoBOIAAAAQAUAlgBA2QgBAUgEAQQgBAugdAtIAAAAIgQAWQg0BDhSAAIgEAAgAiEgLIAAAAQgBAqAXAUQAGAFADAHQAFANAIAKQAOATAUAMIABAAQAcARAeABQA3ABAjgtIANgRIAAAAQATgfABggIABgIQAEgLAAgOQABglgNgZIAAAAQgcgvhMgCQhdgDgmA4IABgBQgSAdgBApg");
	this.shape.setTransform(16.3,16.4);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape},{t:this.instance}]}).wait(1));

}).prototype = getMCSymbolPrototype(lib.lion_mouthGlow, new cjs.Rectangle(-3,-3,45.8,38.9), null);


(lib.LionHead_005 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_stop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":209});

	// Layer 3
	this.mouthmud = new lib.mouthmud5();
	this.mouthmud.parent = this;
	this.mouthmud.setTransform(47.8,66.4,1.4,1.2,0,0,0,22.5,10.5);

	this.manemud = new lib.manemud3();
	this.manemud.parent = this;
	this.manemud.setTransform(-1,36.2,1,1,0,0,0,48.7,44.9);

	this.instance = new lib.LionHead_0050004();
	this.instance.parent = this;
	this.instance.setTransform(-42,-9.4,0.5,0.5);

	this.instance_1 = new lib.LionHead_0050001();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-42,-9.4,0.5,0.5);

	this.instance_2 = new lib.LionHead_0050002();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-42,-9.4,0.5,0.5);

	this.instance_3 = new lib.LionHead_0050003();
	this.instance_3.parent = this;
	this.instance_3.setTransform(-42,-9.4,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance},{t:this.manemud},{t:this.mouthmud}]}).to({state:[{t:this.instance}]},2).to({state:[{t:this.instance_1}]},2).to({state:[{t:this.instance}]},2).to({state:[{t:this.instance_2}]},2).to({state:[{t:this.instance_3}]},2).wait(200));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-50.2,-22,143,175.6);


(lib.LionHead_004 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_stop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":209});

	// Layer 3
	this.mouthmud = new lib.mouthmud4();
	this.mouthmud.parent = this;
	this.mouthmud.setTransform(46.6,67,1.3,1,0,0,0,14.1,11.5);

	this.manemud = new lib.manemud2();
	this.manemud.parent = this;
	this.manemud.setTransform(6.4,32.7,1,1,0,0,0,48.7,44.9);

	this.instance = new lib.LionHead_0040004();
	this.instance.parent = this;
	this.instance.setTransform(-41.9,-7.4,0.5,0.5);

	this.instance_1 = new lib.LionHead_0040001();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-41.9,-7.4,0.5,0.5);

	this.instance_2 = new lib.LionHead_0040002();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-41.9,-7.4,0.5,0.5);

	this.instance_3 = new lib.LionHead_0040003();
	this.instance_3.parent = this;
	this.instance_3.setTransform(-41.9,-7.4,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance},{t:this.manemud},{t:this.mouthmud}]}).to({state:[{t:this.instance}]},2).to({state:[{t:this.instance_1}]},2).to({state:[{t:this.instance}]},2).to({state:[{t:this.instance_2}]},2).to({state:[{t:this.instance_3}]},2).wait(200));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-45,-17.8,136.3,171.4);


(lib.LionHead_003 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_stop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":209,"glowclean":210,"glowclean_loop":211});

	// Layer 3
	this.mouthmud = new lib.mouthmud3();
	this.mouthmud.parent = this;
	this.mouthmud.setTransform(56.9,67.8,1.3,1.1,0,0,0,14.7,13.3);

	this.manemud = new lib.manemud2();
	this.manemud.parent = this;
	this.manemud.setTransform(0.5,32.1,1,1,0,0,0,40.1,44.2);

	this.instance = new lib.LionHead_0030004();
	this.instance.parent = this;
	this.instance.setTransform(-41.4,-7.9,0.5,0.5);

	this.instance_1 = new lib.LionHead_0030001();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-41.4,-7.9,0.5,0.5);

	this.instance_2 = new lib.LionHead_0030002();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-41.4,-7.9,0.5,0.5);

	this.instance_3 = new lib.LionHead_0030003();
	this.instance_3.parent = this;
	this.instance_3.setTransform(-41.4,-7.9,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance},{t:this.manemud},{t:this.mouthmud}]}).to({state:[{t:this.instance}]},2).to({state:[{t:this.instance_1}]},2).to({state:[{t:this.instance}]},2).to({state:[{t:this.instance_2}]},2).to({state:[{t:this.instance_3}]},2).to({state:[]},200).wait(3));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-44.8,-17.4,137.4,170.5);


(lib.LionHead_002 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_stop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":209,"glowclean":210,"glowclean_loop":211});

	// Layer 3
	this.mouthmud = new lib.mouthmud2();
	this.mouthmud.parent = this;
	this.mouthmud.setTransform(66.9,65.7,1.2,1.2,15,0,0,14.3,13.4);

	this.manemud = new lib.lion_maneMud_001();
	this.manemud.parent = this;
	this.manemud.setTransform(14.2,30.5,1,1,0,0,0,40.1,44.2);

	this.instance = new lib.LionHead_0020004();
	this.instance.parent = this;
	this.instance.setTransform(-36.5,-9.4,0.5,0.5);

	this.instance_1 = new lib.LionHead_0020001();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-36.5,-9.4,0.5,0.5);

	this.instance_2 = new lib.LionHead_0020002();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-36.5,-9.4,0.5,0.5);

	this.instance_3 = new lib.LionHead_0020003();
	this.instance_3.parent = this;
	this.instance_3.setTransform(-36.5,-9.4,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance},{t:this.manemud},{t:this.mouthmud}]}).to({state:[{t:this.instance}]},2).to({state:[{t:this.instance_1}]},2).to({state:[{t:this.instance}]},2).to({state:[{t:this.instance_2}]},2).to({state:[{t:this.instance_3}]},2).to({state:[]},200).wait(3));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-45,-17.7,145.6,169.3);


(lib.LionHead_001_wet = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"final":0,"final_loop":1});

	// Layer 3
	this.instance = new lib.LionHead_001_wet0004();
	this.instance.parent = this;
	this.instance.setTransform(-33.9,-7.5,0.5,0.5);

	this.mouthmud = new lib.mouthmud2();
	this.mouthmud.parent = this;
	this.mouthmud.setTransform(53.3,82.2,1,1,0,0,0,14.6,13.3);

	this.manemud = new lib.manemud2();
	this.manemud.parent = this;
	this.manemud.setTransform(2.1,69,1,1,0,0,0,49.4,44.4);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance},{t:this.manemud},{t:this.mouthmud}]},4).to({state:[]},1).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-41.7,-12.8,146.8,167.4);


(lib.mouthmud1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_loop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":70,"glowclean":73,"glowclean_loop":74,"final":75,"final_loop":76});

	// Layer 1
	this.instance = new lib.mouthmudbottom("synched",0);
	this.instance.parent = this;
	this.instance.setTransform(14.2,19.4,0.6,0.6,0,0,0,21.9,11.9);

	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(169,114,78,0.8)").s().p("AgqBiQgdgNgQgCQgOgCgPgOQgLgLgEgIQgHgIgDgTQABgKACgHQAEgOANAAIAEAAQABgGAEgDQAHgGATgBQABgLAHgRQAMggASAAQANAAAPANQAHAGAEAFIACgKQAEgQAMAAQAOAAAFAFIAKAJQAAgHAJgMQAMgOARAAQASAAAPASIACAAQANAAAIAMQAFAJAAAGIgEATQAJAWgBAMQABAfghAnQgnAvg1AAQgkAAgXgKg");
	this.shape.setTransform(14.2,10.8);

	this.instance_1 = new lib.left_over_bubbles();
	this.instance_1.parent = this;
	this.instance_1.setTransform(13.2,12.9,0.389,0.389,-169.7,0,0,50.6,5);

	this.instance_2 = new lib.lion_mouthGlow();
	this.instance_2.parent = this;
	this.instance_2.setTransform(14.5,9.8,1,1,0,0,0,16.3,16.4);

	this.instance_3 = new lib.blueglowmouth();
	this.instance_3.parent = this;
	this.instance_3.setTransform(15.6,7.9,1,1,0,0,0,16.3,16.4);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape},{t:this.instance,p:{mode:"synched",startPosition:0}}]}).to({state:[{t:this.instance_1}]},2).to({state:[{t:this.shape},{t:this.instance,p:{mode:"independent",startPosition:undefined}},{t:this.instance_2}]},2).to({state:[]},2).to({state:[{t:this.instance_1}]},7).to({state:[{t:this.instance_1}]},57).to({state:[{t:this.instance_1},{t:this.instance_3}]},3).to({state:[]},2).to({state:[]},190).wait(39));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,28.3,26.7);


(lib.LionHead_001 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_stop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":209});

	// Layer 6
	this.instance = new lib.lion_mouthGlow();
	this.instance.parent = this;
	this.instance.setTransform(70.9,63.3,1.14,1.14,0,0,0,16.4,16.5);

	this.instance_1 = new lib.lion_maneGlow();
	this.instance_1.parent = this;
	this.instance_1.setTransform(18.5,69.1,1.111,1.111,0,0,180,52.6,66.3);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_1},{t:this.instance}]},4).to({state:[]},2).to({state:[]},204).wait(1));

	// Layer 5
	this.instance_2 = new lib.lion_mouthMud_001_bubbles();
	this.instance_2.parent = this;
	this.instance_2.setTransform(73.5,68.1,1.274,1.094,0,0,0,14.2,10.8);

	this.instance_3 = new lib.lion_maneMud_001_bubbles();
	this.instance_3.parent = this;
	this.instance_3.setTransform(23.8,56.2,1.105,1,0,0,0,37.2,45.9);
	this.instance_3.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_4 = new lib.lion_mouthMud_002_bubbles();
	this.instance_4.parent = this;
	this.instance_4.setTransform(54.3,75,0.765,0.843,0,0,0,20.9,12.8);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_4},{t:this.instance_3},{t:this.instance_2}]},6).wait(205));

	// Layer 3
	this.mouthmud = new lib.mouthmud1();
	this.mouthmud.parent = this;
	this.mouthmud.setTransform(70.6,66.2,1.2,1.2,0,0,0,14.2,10.8);

	this.manemud = new lib.lion_maneMud_001();
	this.manemud.parent = this;
	this.manemud.setTransform(18.1,32.5,1,1,0,0,0,40.9,44.2);

	this.instance_5 = new lib.LionHead_0010004();
	this.instance_5.parent = this;
	this.instance_5.setTransform(-35,-7.4,0.5,0.5);

	this.instance_6 = new lib.LionHead_0010001();
	this.instance_6.parent = this;
	this.instance_6.setTransform(-35,-7.4,0.5,0.5);

	this.instance_7 = new lib.LionHead_0010002();
	this.instance_7.parent = this;
	this.instance_7.setTransform(-35,-7.4,0.5,0.5);

	this.instance_8 = new lib.LionHead_0010003();
	this.instance_8.parent = this;
	this.instance_8.setTransform(-35,-7.4,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_5},{t:this.manemud},{t:this.mouthmud}]}).to({state:[{t:this.instance_5}]},2).to({state:[{t:this.instance_6}]},2).to({state:[{t:this.instance_5}]},2).to({state:[{t:this.instance_7}]},2).to({state:[{t:this.instance_8}]},2).to({state:[]},200).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-42.2,-15.9,146.3,168.5);


(lib.Lion = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{wrongAnswer:0,rest:41,rest_stop:104,"clean":106,clean_stop:113,wet:115,wet_stop:129,excited:131,excited_stop:210,animalSound:212});

	// timeline functions:
	this.frame_39 = function() {
		/* gotoAndPlay("rest");*/
	}
	this.frame_104 = function() {
		/* stop();
		
		gameObjects._animal.restTimeout();*/
	}
	this.frame_113 = function() {
		/* stop();*/
	}
	this.frame_129 = function() {
		/* stop();*/
	}
	this.frame_211 = function() {
		/* 
		
		gameObjects._game.done();
		stop();*/
	}
	this.frame_240 = function() {
		/* gotoAndPlay("rest");*/
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).wait(39).call(this.frame_39).wait(65).call(this.frame_104).wait(9).call(this.frame_113).wait(16).call(this.frame_129).wait(82).call(this.frame_211).wait(29).call(this.frame_240).wait(41));

	// legs
	this.legs_bubbles = new lib.LionHindLeg_bubbles();
	this.legs_bubbles.parent = this;
	this.legs_bubbles.setTransform(485.7,81.2,0.483,0.483,0,5.7,-174.3,11.6,-56.8);

	this.timeline.addTween(cjs.Tween.get(this.legs_bubbles).wait(41).to({_off:true},74).wait(166));

	// mouth
	this.mouth_bubbles = new lib.LionHead_001_bubbles();
	this.mouth_bubbles.parent = this;
	this.mouth_bubbles.setTransform(413.1,65.5,0.556,0.556,0,5.7,-174.3,-14.8,66.1);

	this.timeline.addTween(cjs.Tween.get(this.mouth_bubbles).wait(41).to({_off:true},74).wait(166));

	// mane
	this.mane_bubbles = new lib.LionFrontLeg_bubbles();
	this.mane_bubbles.parent = this;
	this.mane_bubbles.setTransform(413.8,76.2,0.483,0.483,0,5.7,-174.3,-16.9,-58.9);

	this.timeline.addTween(cjs.Tween.get(this.mane_bubbles).wait(41).to({_off:true},74).wait(166));

	// Lion Torso
	this.back_bubbles = new lib.LionTorso_bubbles();
	this.back_bubbles.parent = this;
	this.back_bubbles.setTransform(448.4,84.7,0.483,0.483,0,5.7,-174.3);

	this.timeline.addTween(cjs.Tween.get(this.back_bubbles).wait(41).to({_off:true},74).wait(166));

	// feet
	this.paws_bubbles = new lib.LionFrontLegBack_bubbles();
	this.paws_bubbles.parent = this;
	this.paws_bubbles.setTransform(397,78,0.483,0.483,0,5.7,-174.3,-2.6,-53.6);

	this.timeline.addTween(cjs.Tween.get(this.paws_bubbles).wait(41).to({_off:true},74).wait(166));

	// sparkle
	this.instance = new lib.sparkle();
	this.instance.parent = this;
	this.instance.setTransform(488.6,74.3,0.502,0.502);
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(187).to({_off:false},0).to({_off:true},25).wait(69));

	// sparkle
	this.instance_1 = new lib.sparkle();
	this.instance_1.parent = this;
	this.instance_1.setTransform(400.1,129,0.406,0.406);
	this.instance_1._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(191).to({_off:false},0).to({_off:true},21).wait(69));

	// sparkle
	this.instance_2 = new lib.sparkle();
	this.instance_2.parent = this;
	this.instance_2.setTransform(500.2,110.7,0.75,0.75);
	this.instance_2._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(197).to({_off:false},0).to({_off:true},15).wait(69));

	// Layer 3
	this.instance_3 = new lib.water_drops_014();
	this.instance_3.parent = this;
	this.instance_3.setTransform(455.1,77.9,0.6,0.6,0,0,180,92.4,49.1);
	this.instance_3._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_3).wait(115).to({_off:false},0).to({_off:true},16).wait(150));

	// sparkle
	this.instance_4 = new lib.sparkle();
	this.instance_4.parent = this;
	this.instance_4.setTransform(437.2,101.4,0.75,0.75);
	this.instance_4._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_4).wait(201).to({_off:false},0).to({_off:true},11).wait(69));

	// sparkle
	this.instance_5 = new lib.sparkle();
	this.instance_5.parent = this;
	this.instance_5.setTransform(387.9,74.9,0.75,0.75);
	this.instance_5._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_5).wait(207).to({_off:false},0).to({_off:true},5).wait(69));

	// Lion Head Front
	this.lion_head = new lib.LionHead_001();
	this.lion_head.parent = this;
	this.lion_head.setTransform(413.1,65.5,0.556,0.556,0,5.7,-174.3,-14.8,66.1);

	this.lion_head_1 = new lib.LionHead_002();
	this.lion_head_1.parent = this;
	this.lion_head_1.setTransform(413.1,66.7,0.555,0.555,0,5.6,-174.4,-14.8,66.2);

	this.lion_head_2 = new lib.LionHead_003();
	this.lion_head_2.parent = this;
	this.lion_head_2.setTransform(413.2,67.7,0.555,0.555,0,5.6,-174.4,-14.8,66.1);

	this.lion_head_3 = new lib.LionHead_004();
	this.lion_head_3.parent = this;
	this.lion_head_3.setTransform(408.5,31.5,0.555,0.555,0,5.6,-174.4);

	this.lion_head_4 = new lib.LionHead_005();
	this.lion_head_4.parent = this;
	this.lion_head_4.setTransform(407.2,32.4,0.556,0.556,0,3.5,-174.3);

	this.lion_head_5 = new lib.LionHead_001_wet();
	this.lion_head_5.parent = this;
	this.lion_head_5.setTransform(413.1,65.5,0.556,0.556,0,5.7,-174.3,-14.8,66.1);

	this.lion_roar = new lib.LionHead_roar_002();
	this.lion_roar.parent = this;
	this.lion_roar.setTransform(411.7,65.6,0.555,0.555,0,5.6,-174.4,-14.7,66.2);
	this.lion_roar._off = true;

	this.lion_roar_1 = new lib.LionHead_roar_003();
	this.lion_roar_1.parent = this;
	this.lion_roar_1.setTransform(406.8,65.6,0.555,0.555,0,5.6,-174.4,-14.8,66.2);

	this.lion_roar_2 = new lib.LionHead_roar_004();
	this.lion_roar_2.parent = this;
	this.lion_roar_2.setTransform(401.9,65.6,0.555,0.555,0,5.6,-174.4,-14.8,66.2);

	this.lion_roar_3 = new lib.LionHead_roar_005();
	this.lion_roar_3.parent = this;
	this.lion_roar_3.setTransform(396.9,65.5,0.556,0.556,0,5.7,-174.3,-14.8,66.1);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.lion_head}]}).to({state:[{t:this.lion_head_1}]},5).to({state:[{t:this.lion_head_2}]},1).to({state:[{t:this.lion_head_3,p:{regX:0,regY:0,x:408.5,y:31.5}}]},1).to({state:[{t:this.lion_head_4}]},1).to({state:[{t:this.lion_head_3,p:{regX:-14.8,regY:66.2,x:413.2,y:68.9}}]},17).to({state:[{t:this.lion_head_2}]},1).to({state:[{t:this.lion_head_1}]},1).to({state:[{t:this.lion_head}]},1).to({state:[{t:this.lion_head}]},13).to({state:[{t:this.lion_head_1}]},20).to({state:[{t:this.lion_head_2}]},1).to({state:[{t:this.lion_head_3,p:{regX:0,regY:0,x:408.5,y:31.5}}]},1).to({state:[{t:this.lion_head_4}]},1).to({state:[{t:this.lion_head_3,p:{regX:-14.8,regY:66.2,x:413.2,y:68.9}}]},22).to({state:[{t:this.lion_head_2}]},1).to({state:[{t:this.lion_head_1}]},1).to({state:[{t:this.lion_head}]},1).to({state:[{t:this.lion_head}]},17).to({state:[{t:this.lion_head_5}]},9).to({state:[{t:this.lion_head}]},16).to({state:[{t:this.lion_roar}]},24).to({state:[{t:this.lion_roar_1}]},1).to({state:[{t:this.lion_roar_2}]},1).to({state:[{t:this.lion_roar_3}]},1).to({state:[{t:this.lion_roar_3}]},19).to({state:[{t:this.lion_roar_2}]},2).to({state:[{t:this.lion_roar_1}]},2).to({state:[{t:this.lion_roar}]},1).to({state:[{t:this.lion_roar}]},1).to({state:[{t:this.lion_head}]},1).to({state:[{t:this.lion_head}]},28).to({state:[{t:this.lion_roar}]},3).to({state:[{t:this.lion_roar_1}]},1).to({state:[{t:this.lion_roar_2}]},1).to({state:[{t:this.lion_roar_3}]},1).to({state:[{t:this.lion_roar_3}]},14).to({state:[{t:this.lion_roar_2}]},2).to({state:[{t:this.lion_roar_1}]},2).to({state:[{t:this.lion_roar}]},1).to({state:[{t:this.lion_roar}]},1).to({state:[{t:this.lion_head}]},1).to({state:[]},2).wait(40));
	this.timeline.addTween(cjs.Tween.get(this.lion_head).to({_off:true},5).wait(23).to({_off:false},0).wait(13).to({_off:true},20).wait(28).to({_off:false},0).wait(17).to({_off:true},9).wait(16).to({_off:false},0).to({_off:true},24).wait(29).to({_off:false},0).wait(28).to({_off:true},3).wait(24).to({_off:false},0).to({_off:true},2).wait(40));
	this.timeline.addTween(cjs.Tween.get(this.lion_roar).wait(155).to({_off:false},0).to({_off:true},1).wait(26).to({_off:false},0).wait(1).to({skewX:5.5,skewY:-174.5,x:412.4},0).to({_off:true},1).wait(31).to({_off:false,skewX:5.6,skewY:-174.4,x:411.7},0).to({_off:true},1).wait(21).to({_off:false},0).wait(1).to({skewX:5.5,skewY:-174.5,x:412.4},0).to({_off:true},1).wait(42));

	// Lion Front Leg
	this.lion_frontleg = new lib.LionFrontLeg();
	this.lion_frontleg.parent = this;
	this.lion_frontleg.setTransform(413.8,76.2,0.483,0.483,0,5.7,-174.3,-16.9,-58.9);

	this.timeline.addTween(cjs.Tween.get(this.lion_frontleg).wait(5).to({regY:-57.9,scaleX:0.48,scaleY:0.47,skewX:6.6,skewY:-174.7,x:414.7,y:78.7},0).wait(1).to({regX:-17,scaleY:0.46,skewX:7.7,skewY:-174.8,x:415.8,y:80.8},0).wait(1).to({regX:-16.9,regY:-58,scaleX:0.48,scaleY:0.47,skewX:8.3,skewY:-174.7,x:416.8,y:78.8},0).wait(1).to({regX:-17.1,regY:-57.9,scaleY:0.49,skewX:9,skewY:-174.2,x:417.7,y:76.7},0).wait(17).to({regX:-16.9,regY:-58,scaleY:0.47,skewX:8.3,skewY:-174.7,x:416.8,y:78.8},0).wait(1).to({regX:-17,regY:-57.9,scaleX:0.48,scaleY:0.46,skewX:7.7,skewY:-174.8,x:415.8,y:80.8},0).wait(1).to({regX:-16.9,scaleY:0.47,skewX:6.6,skewY:-174.7,x:414.7,y:78.7},0).wait(1).to({regY:-58.9,scaleX:0.48,scaleY:0.48,skewX:5.7,skewY:-174.3,x:413.8,y:76.2},0).wait(33).to({regY:-57.9,scaleX:0.48,scaleY:0.47,skewX:6.6,skewY:-174.7,x:414.7,y:78.7},0).wait(1).to({regX:-17,scaleY:0.46,skewX:7.7,skewY:-174.8,x:415.8,y:80.8},0).wait(1).to({regX:-16.9,regY:-58,scaleX:0.48,scaleY:0.47,skewX:8.3,skewY:-174.7,x:416.8,y:78.8},0).wait(1).to({regX:-17.1,regY:-57.9,scaleY:0.49,skewX:9,skewY:-174.2,x:417.7,y:76.7},0).wait(22).to({regX:-16.9,regY:-58,scaleY:0.47,skewX:8.3,skewY:-174.7,x:416.8,y:78.8},0).wait(1).to({regX:-17,regY:-57.9,scaleX:0.48,scaleY:0.46,skewX:7.7,skewY:-174.8,x:415.8,y:80.8},0).wait(1).to({regX:-16.9,scaleY:0.47,skewX:6.6,skewY:-174.7,x:414.7,y:78.7},0).wait(1).to({regY:-58.9,scaleX:0.48,scaleY:0.48,skewX:5.7,skewY:-174.3,x:413.8,y:76.2},0).wait(66).to({regX:-17,scaleX:0.48,scaleY:0.49,skewX:7.3,skewY:-174.4,x:415.8},0).wait(1).to({regX:-17.1,scaleX:0.49,scaleY:0.49,skewX:3.8,x:411.4,y:76.3},0).wait(1).to({regX:-17,scaleX:0.49,scaleY:0.48,skewX:0.3,skewY:-174.5,x:406.8,y:76.2},0).wait(1).to({regX:-16.9,scaleX:0.49,scaleY:0.48,skewX:-3.2,skewY:-174.4,x:402.3},0).wait(21).to({regX:-17,scaleX:0.49,scaleY:0.48,skewX:0.3,skewY:-174.5,x:406.8},0).wait(2).to({regX:-17.1,scaleX:0.49,scaleY:0.49,skewX:3.8,skewY:-174.4,x:411.4,y:76.3},0).wait(1).to({regX:-17,scaleX:0.48,scaleY:0.49,skewX:7.3,x:415.8,y:76.2},0).wait(1).to({regX:-17.1,scaleY:0.49,skewX:6.5,skewY:-174.5,x:414.8,y:76.3},0).wait(1).to({regX:-16.9,scaleX:0.48,scaleY:0.48,skewX:5.7,skewY:-174.3,x:413.8,y:76.2},0).wait(31).to({regX:-17,scaleX:0.48,scaleY:0.49,skewX:7.3,skewY:-174.4,x:415.8},0).wait(1).to({regX:-17.1,scaleX:0.49,scaleY:0.49,skewX:3.8,x:411.4,y:76.3},0).wait(1).to({regX:-17,scaleX:0.49,scaleY:0.48,skewX:0.3,skewY:-174.5,x:406.8,y:76.2},0).wait(1).to({regX:-16.9,scaleX:0.49,scaleY:0.48,skewX:-3.2,skewY:-174.4,x:402.3},0).wait(16).to({regX:-17,scaleX:0.49,scaleY:0.48,skewX:0.3,skewY:-174.5,x:406.8},0).wait(2).to({regX:-17.1,scaleX:0.49,scaleY:0.49,skewX:3.8,skewY:-174.4,x:411.4,y:76.3},0).wait(1).to({regX:-17,scaleX:0.48,scaleY:0.49,skewX:7.3,x:415.8,y:76.2},0).wait(1).to({regX:-17.1,scaleY:0.49,skewX:6.5,skewY:-174.5,x:414.8,y:76.3},0).wait(1).to({regX:-16.9,scaleX:0.48,scaleY:0.48,skewX:5.7,skewY:-174.3,x:413.8,y:76.2},0).to({_off:true},2).wait(40));

	// Lion Hind Leg
	this.lion_hindleg = new lib.LionHindLeg();
	this.lion_hindleg.parent = this;
	this.lion_hindleg.setTransform(485.7,81.2,0.483,0.483,0,5.7,-174.3,11.6,-56.8);

	this.timeline.addTween(cjs.Tween.get(this.lion_hindleg).wait(5).to({regX:11.5,regY:-56.7,scaleX:0.48,skewX:4.8,skewY:-174.5,x:484.6,y:81.3},0).wait(1).to({regX:11.3,regY:-56.9,scaleX:0.49,scaleY:0.48,skewX:3.8,skewY:-174.4,x:483.7,y:81.2},0).wait(1).to({regX:11.6,regY:-56.8,scaleX:0.48,scaleY:0.48,skewX:4.8,skewY:-174.5,x:484.6},0).wait(1).to({scaleX:0.48,skewX:5.7,skewY:-174.3,x:485.7},0).wait(17).to({scaleX:0.48,skewX:4.8,skewY:-174.5,x:484.6},0).wait(1).to({regX:11.3,regY:-56.9,scaleX:0.49,scaleY:0.48,skewX:3.8,skewY:-174.4,x:483.7},0).wait(1).to({regX:11.5,regY:-56.7,scaleX:0.48,scaleY:0.48,skewX:4.8,skewY:-174.5,x:484.6,y:81.3},0).wait(1).to({regX:11.6,regY:-56.8,scaleX:0.48,skewX:5.7,skewY:-174.3,x:485.7,y:81.2},0).wait(33).to({regX:11.5,regY:-56.7,scaleX:0.48,skewX:4.8,skewY:-174.5,x:484.6,y:81.3},0).wait(1).to({regX:11.3,regY:-56.9,scaleX:0.49,scaleY:0.48,skewX:3.8,skewY:-174.4,x:483.7,y:81.2},0).wait(1).to({regX:11.6,regY:-56.8,scaleX:0.48,scaleY:0.48,skewX:4.8,skewY:-174.5,x:484.6},0).wait(1).to({scaleX:0.48,skewX:5.7,skewY:-174.3,x:485.7},0).wait(22).to({scaleX:0.48,skewX:4.8,skewY:-174.5,x:484.6},0).wait(1).to({regX:11.3,regY:-56.9,scaleX:0.49,scaleY:0.48,skewX:3.8,skewY:-174.4,x:483.7},0).wait(1).to({regX:11.5,regY:-56.7,scaleX:0.48,scaleY:0.48,skewX:4.8,skewY:-174.5,x:484.6,y:81.3},0).wait(1).to({regX:11.6,regY:-56.8,scaleX:0.48,skewX:5.7,skewY:-174.3,x:485.7,y:81.2},0).wait(66).to({regX:10.8,scaleX:0.48,scaleY:0.48,skewX:4.6,skewY:-174.4,x:486.4},0).wait(1).to({regX:11.8,scaleX:0.49,scaleY:0.48,skewX:2,skewY:-174.5,x:482.1,y:81.1},0).wait(1).to({regX:11.6,regY:-56.7,scaleX:0.49,scaleY:0.48,skewX:-0.5,x:478.6,y:81.2},0).wait(1).to({regX:10.8,regY:-57,scaleX:0.49,skewX:-3.2,skewY:-174.4,x:475.4},0).wait(21).to({regX:11.6,regY:-56.7,scaleX:0.49,skewX:-0.5,skewY:-174.5,x:478.6},0).wait(2).to({regX:11.8,regY:-56.8,scaleX:0.49,scaleY:0.48,skewX:2,x:482.1,y:81.1},0).wait(1).to({regX:10.8,scaleX:0.48,scaleY:0.48,skewX:4.6,skewY:-174.4,x:486.4,y:81.2},0).wait(1).to({scaleX:0.48,scaleY:0.48,skewX:5,skewY:-174.5,x:486.1},0).wait(1).to({regX:11.6,skewX:5.7,skewY:-174.3,x:485.7},0).wait(31).to({regX:10.8,scaleX:0.48,scaleY:0.48,skewX:4.6,skewY:-174.4,x:486.4},0).wait(1).to({regX:11.8,scaleX:0.49,scaleY:0.48,skewX:2,skewY:-174.5,x:482.1,y:81.1},0).wait(1).to({regX:11.6,regY:-56.7,scaleX:0.49,scaleY:0.48,skewX:-0.5,x:478.6,y:81.2},0).wait(1).to({regX:10.8,regY:-57,scaleX:0.49,skewX:-3.2,skewY:-174.4,x:475.4},0).wait(16).to({regX:11.6,regY:-56.7,scaleX:0.49,skewX:-0.5,skewY:-174.5,x:478.6},0).wait(2).to({regX:11.8,regY:-56.8,scaleX:0.49,scaleY:0.48,skewX:2,x:482.1,y:81.1},0).wait(1).to({regX:10.8,scaleX:0.48,scaleY:0.48,skewX:4.6,skewY:-174.4,x:486.4,y:81.2},0).wait(1).to({scaleX:0.48,scaleY:0.48,skewX:5,skewY:-174.5,x:486.1},0).wait(1).to({regX:11.6,skewX:5.7,skewY:-174.3,x:485.7},0).to({_off:true},2).wait(40));

	// Lion Torso
	this.lion_torso = new lib.LionTorso();
	this.lion_torso.parent = this;
	this.lion_torso.setTransform(421.8,88.1,0.483,0.483,0,5.7,-174.3,54.1,12.6);

	this.lion_torso_1 = new lib.LionTorso_wet();
	this.lion_torso_1.parent = this;
	this.lion_torso_1.setTransform(421.8,88.1,0.483,0.483,0,5.7,-174.3,54.1,12.6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.lion_torso}]}).to({state:[{t:this.lion_torso}]},5).to({state:[{t:this.lion_torso}]},1).to({state:[{t:this.lion_torso}]},1).to({state:[{t:this.lion_torso}]},1).to({state:[{t:this.lion_torso}]},17).to({state:[{t:this.lion_torso}]},1).to({state:[{t:this.lion_torso}]},1).to({state:[{t:this.lion_torso}]},1).to({state:[{t:this.lion_torso}]},13).to({state:[{t:this.lion_torso}]},20).to({state:[{t:this.lion_torso}]},1).to({state:[{t:this.lion_torso}]},1).to({state:[{t:this.lion_torso}]},1).to({state:[{t:this.lion_torso}]},22).to({state:[{t:this.lion_torso}]},1).to({state:[{t:this.lion_torso}]},1).to({state:[{t:this.lion_torso}]},1).to({state:[{t:this.lion_torso}]},17).to({state:[{t:this.lion_torso_1}]},9).to({state:[{t:this.lion_torso}]},16).to({state:[{t:this.lion_torso}]},24).to({state:[{t:this.lion_torso}]},1).to({state:[{t:this.lion_torso}]},1).to({state:[{t:this.lion_torso}]},1).to({state:[{t:this.lion_torso}]},19).to({state:[{t:this.lion_torso}]},2).to({state:[{t:this.lion_torso}]},2).to({state:[{t:this.lion_torso}]},1).to({state:[{t:this.lion_torso}]},1).to({state:[{t:this.lion_torso}]},1).to({state:[{t:this.lion_torso}]},28).to({state:[{t:this.lion_torso}]},3).to({state:[{t:this.lion_torso}]},1).to({state:[{t:this.lion_torso}]},1).to({state:[{t:this.lion_torso}]},1).to({state:[{t:this.lion_torso}]},14).to({state:[{t:this.lion_torso}]},2).to({state:[{t:this.lion_torso}]},2).to({state:[{t:this.lion_torso}]},1).to({state:[{t:this.lion_torso}]},1).to({state:[{t:this.lion_torso}]},1).to({state:[]},2).wait(40));
	this.timeline.addTween(cjs.Tween.get(this.lion_torso).wait(5).to({regX:54,regY:12.7,skewX:5.5,skewY:-175,x:421.7,y:89.1},0).wait(1).to({regX:54.1,regY:12.5,skewX:5.6,skewY:-175.5,x:421.5,y:89.9},0).wait(1).to({regY:13.1,skewX:5.5,skewY:-176.2,y:90.3},0).wait(1).to({regX:54,regY:12.5,scaleX:0.48,skewX:5.7,skewY:-176.9,y:89.9},0).wait(17).to({regX:54.1,regY:13.1,scaleX:0.48,skewX:5.5,skewY:-176.2,y:90.3},0).wait(1).to({regY:12.5,skewX:5.6,skewY:-175.5,y:89.9},0).wait(1).to({regX:54,regY:12.7,skewX:5.5,skewY:-175,x:421.7,y:89.1},0).wait(1).to({regX:54.1,regY:12.6,skewX:5.7,skewY:-174.3,x:421.8,y:88.1},0).wait(33).to({regX:54,regY:12.7,skewX:5.5,skewY:-175,x:421.7,y:89.1},0).wait(1).to({regX:54.1,regY:12.5,skewX:5.6,skewY:-175.5,x:421.5,y:89.9},0).wait(1).to({regY:13.1,skewX:5.5,skewY:-176.2,y:90.3},0).wait(1).to({regX:54,regY:12.5,scaleX:0.48,skewX:5.7,skewY:-176.9,y:89.9},0).wait(22).to({regX:54.1,regY:13.1,scaleX:0.48,skewX:5.5,skewY:-176.2,y:90.3},0).wait(1).to({regY:12.5,skewX:5.6,skewY:-175.5,y:89.9},0).wait(1).to({regX:54,regY:12.7,skewX:5.5,skewY:-175,x:421.7,y:89.1},0).wait(1).to({regX:54.1,regY:12.6,skewX:5.7,skewY:-174.3,x:421.8,y:88.1},0).wait(17).to({_off:true},9).wait(16).to({_off:false},0).wait(24).to({regX:54,scaleX:0.48,scaleY:0.48,skewX:4.6,skewY:-174.4,x:422.1,y:88.2},0).wait(1).to({regX:54.1,scaleX:0.49,scaleY:0.48,skewX:2,skewY:-174.5,x:418.8},0).wait(1).to({regX:54,scaleX:0.49,scaleY:0.48,skewX:-0.5,x:415.5},0).wait(1).to({regX:54.1,scaleX:0.49,skewX:-3.2,skewY:-174.4,x:412.2,y:88.1},0).wait(21).to({regX:54,scaleX:0.49,skewX:-0.5,skewY:-174.5,x:415.5,y:88.2},0).wait(2).to({regX:54.1,scaleX:0.49,scaleY:0.48,skewX:2,x:418.8},0).wait(1).to({regX:54,scaleX:0.48,scaleY:0.48,skewX:4.6,skewY:-174.4,x:422.1},0).wait(1).to({regX:53.8,regY:13.7,scaleX:0.48,scaleY:0.48,skewX:5,skewY:-174.5,x:422,y:88.7},0).wait(1).to({regX:54.1,regY:12.6,skewX:5.7,skewY:-174.3,x:421.8,y:88.1},0).wait(31).to({regX:54,scaleX:0.48,scaleY:0.48,skewX:4.6,skewY:-174.4,x:422.1,y:88.2},0).wait(1).to({regX:54.1,scaleX:0.49,scaleY:0.48,skewX:2,skewY:-174.5,x:418.8},0).wait(1).to({regX:54,scaleX:0.49,scaleY:0.48,skewX:-0.5,x:415.5},0).wait(1).to({regX:54.1,scaleX:0.49,skewX:-3.2,skewY:-174.4,x:412.2,y:88.1},0).wait(16).to({regX:54,scaleX:0.49,skewX:-0.5,skewY:-174.5,x:415.5,y:88.2},0).wait(2).to({regX:54.1,scaleX:0.49,scaleY:0.48,skewX:2,x:418.8},0).wait(1).to({regX:54,scaleX:0.48,scaleY:0.48,skewX:4.6,skewY:-174.4,x:422.1},0).wait(1).to({regX:53.8,regY:13.7,scaleX:0.48,scaleY:0.48,skewX:5,skewY:-174.5,x:422,y:88.7},0).wait(1).to({regX:54.1,regY:12.6,skewX:5.7,skewY:-174.3,x:421.8,y:88.1},0).to({_off:true},2).wait(40));

	// Lion Tail
	this.instance_6 = new lib.LionTail_1();
	this.instance_6.parent = this;
	this.instance_6.setTransform(503.1,81.4,0.483,0.483,0,5.7,-174.3,2.1,-40.8);

	this.timeline.addTween(cjs.Tween.get(this.instance_6).wait(5).to({skewX:3.3,skewY:-176.7,y:81.8},0).wait(1).to({regX:7.1,regY:-30.4,skewX:1.1,skewY:-178.9,x:500.6,y:87.2},0).wait(1).to({regX:2.1,regY:-40.6,skewX:3.3,skewY:-176.7,x:503.1,y:81.8},0).wait(1).to({regY:-40.8,skewX:5.7,skewY:-174.3,y:81.4},0).wait(17).to({regY:-40.6,skewX:3.3,skewY:-176.7,y:81.8},0).wait(1).to({regX:7.1,regY:-30.2,skewX:1.1,skewY:-178.9,x:500.6,y:87.3},0).wait(1).to({regX:2.1,regY:-40.8,skewX:3.3,skewY:-176.7,x:503.1,y:81.8},0).wait(1).to({skewX:5.7,skewY:-174.3,y:81.4},0).wait(33).to({skewX:3.3,skewY:-176.7,y:81.8},0).wait(1).to({regX:7.1,regY:-30.6,skewX:1.1,skewY:-178.9,x:500.6,y:87.1},0).wait(1).to({regX:2.1,regY:-40.6,skewX:3.3,skewY:-176.7,x:503.1,y:81.8},0).wait(1).to({regY:-40.8,skewX:5.7,skewY:-174.3,y:81.4},0).wait(22).to({regY:-40.6,skewX:3.3,skewY:-176.7,y:81.8},0).wait(1).to({regX:7.1,regY:-30.4,skewX:1.1,skewY:-178.9,x:500.6,y:87.2},0).wait(1).to({regX:2.1,regY:-40.8,skewX:3.3,skewY:-176.7,x:503.1,y:81.8},0).wait(1).to({skewX:5.7,skewY:-174.3,y:81.4},0).wait(66).to({regY:-40.9,scaleX:0.48,scaleY:0.49,skewX:3.5,skewY:-182.8,x:504.6,y:80.6},0).wait(1).to({scaleY:0.49,skewX:-6.8,skewY:-191.3,x:502.1,y:80},0).wait(1).to({regX:2,regY:-40.8,scaleY:0.49,skewX:-17.5,skewY:-199.8,x:499.8,y:79.4},0).wait(1).to({regX:2.2,regY:-40.9,scaleX:0.48,scaleY:0.48,skewX:-28.3,skewY:-208.3,x:497.3,y:78.7},0).wait(21).to({regX:2,regY:-40.8,scaleX:0.48,scaleY:0.49,skewX:-17.5,skewY:-199.8,x:499.8,y:79.4},0).wait(2).to({regX:2.1,regY:-40.9,scaleY:0.49,skewX:-6.8,skewY:-191.3,x:502.1,y:80},0).wait(1).to({scaleY:0.49,skewX:3.5,skewY:-182.8,x:504.6,y:80.6},0).wait(1).to({regX:1.9,regY:-38.9,scaleX:0.48,scaleY:0.49,skewX:4.5,skewY:-178.7,x:503.9,y:82},0).wait(1).to({regX:2.1,regY:-40.8,scaleY:0.48,skewX:5.7,skewY:-174.3,x:503.1,y:81.4},0).wait(31).to({regY:-40.9,scaleX:0.48,scaleY:0.49,skewX:3.5,skewY:-182.8,x:504.6,y:80.6},0).wait(1).to({scaleY:0.49,skewX:-6.8,skewY:-191.3,x:502.1,y:80},0).wait(1).to({regX:2,regY:-40.8,scaleY:0.49,skewX:-17.5,skewY:-199.8,x:499.8,y:79.4},0).wait(1).to({regX:2.2,regY:-40.9,scaleX:0.48,scaleY:0.48,skewX:-28.3,skewY:-208.3,x:497.3,y:78.7},0).wait(16).to({regX:2,regY:-40.8,scaleX:0.48,scaleY:0.49,skewX:-17.5,skewY:-199.8,x:499.8,y:79.4},0).wait(2).to({regX:2.1,regY:-40.9,scaleY:0.49,skewX:-6.8,skewY:-191.3,x:502.1,y:80},0).wait(1).to({scaleY:0.49,skewX:3.5,skewY:-182.8,x:504.6,y:80.6},0).wait(1).to({regX:1.9,regY:-38.8,scaleX:0.48,scaleY:0.49,skewX:4.5,skewY:-178.7,x:503.9,y:82.1},0).wait(1).to({regX:2.1,regY:-40.8,scaleY:0.48,skewX:5.7,skewY:-174.3,x:503.1,y:81.4},0).to({_off:true},2).wait(40));

	// Lion Hind Leg Back
	this.lion_hindlegback = new lib.LionHindLegBack();
	this.lion_hindlegback.parent = this;
	this.lion_hindlegback.setTransform(477.5,83.6,0.483,0.483,0,5.7,-174.3,12.8,-49.5);

	this.timeline.addTween(cjs.Tween.get(this.lion_hindlegback).wait(5).to({scaleX:0.48,skewX:4.8,skewY:-174.5,x:476.5,y:83.7},0).wait(1).to({regX:12.9,scaleX:0.49,scaleY:0.48,skewX:3.8,skewY:-174.4,x:475.3,y:83.6},0).wait(1).to({regX:12.8,scaleX:0.48,scaleY:0.48,skewX:4.8,skewY:-174.5,x:476.5},0).wait(1).to({scaleX:0.48,skewX:5.7,skewY:-174.3,x:477.5},0).wait(17).to({scaleX:0.48,skewX:4.8,skewY:-174.5,x:476.5},0).wait(1).to({regX:12.9,scaleX:0.49,scaleY:0.48,skewX:3.8,skewY:-174.4,x:475.3},0).wait(1).to({regX:12.8,scaleX:0.48,scaleY:0.48,skewX:4.8,skewY:-174.5,x:476.5,y:83.7},0).wait(1).to({scaleX:0.48,skewX:5.7,skewY:-174.3,x:477.5,y:83.6},0).wait(33).to({scaleX:0.48,skewX:4.8,skewY:-174.5,x:476.5,y:83.7},0).wait(1).to({regX:12.9,scaleX:0.49,scaleY:0.48,skewX:3.8,skewY:-174.4,x:475.3,y:83.6},0).wait(1).to({regX:12.8,scaleX:0.48,scaleY:0.48,skewX:4.8,skewY:-174.5,x:476.5},0).wait(1).to({scaleX:0.48,skewX:5.7,skewY:-174.3,x:477.5},0).wait(22).to({scaleX:0.48,skewX:4.8,skewY:-174.5,x:476.5},0).wait(1).to({regX:12.9,scaleX:0.49,scaleY:0.48,skewX:3.8,skewY:-174.4,x:475.3},0).wait(1).to({regX:12.8,scaleX:0.48,scaleY:0.48,skewX:4.8,skewY:-174.5,x:476.5,y:83.7},0).wait(1).to({scaleX:0.48,skewX:5.7,skewY:-174.3,x:477.5,y:83.6},0).wait(66).to({scaleX:0.48,scaleY:0.48,skewX:4.6,skewY:-174.4,x:477.7,y:83.5},0).wait(1).to({scaleX:0.49,scaleY:0.48,skewX:2,skewY:-174.5,x:474.2,y:83.6},0).wait(1).to({regX:12.6,regY:-49.3,scaleX:0.49,scaleY:0.48,skewX:-0.5,x:470.8},0).wait(1).to({regX:12.7,regY:-49.5,scaleX:0.49,skewX:-3.2,skewY:-174.4,x:467.2},0).wait(21).to({regX:12.6,regY:-49.3,scaleX:0.49,skewX:-0.5,skewY:-174.5,x:470.8},0).wait(2).to({regX:12.8,regY:-49.5,scaleX:0.49,scaleY:0.48,skewX:2,x:474.2},0).wait(1).to({scaleX:0.48,scaleY:0.48,skewX:4.6,skewY:-174.4,x:477.7,y:83.5},0).wait(1).to({scaleX:0.48,scaleY:0.48,skewX:5,skewY:-174.5,x:477.6},0).wait(1).to({skewX:5.7,skewY:-174.3,x:477.5,y:83.6},0).wait(31).to({scaleX:0.48,scaleY:0.48,skewX:4.6,skewY:-174.4,x:477.7,y:83.5},0).wait(1).to({scaleX:0.49,scaleY:0.48,skewX:2,skewY:-174.5,x:474.2,y:83.6},0).wait(1).to({regX:12.6,regY:-49.3,scaleX:0.49,scaleY:0.48,skewX:-0.5,x:470.8},0).wait(1).to({regX:12.7,regY:-49.5,scaleX:0.49,skewX:-3.2,skewY:-174.4,x:467.2},0).wait(16).to({regX:12.6,regY:-49.3,scaleX:0.49,skewX:-0.5,skewY:-174.5,x:470.8},0).wait(2).to({regX:12.8,regY:-49.5,scaleX:0.49,scaleY:0.48,skewX:2,x:474.2},0).wait(1).to({scaleX:0.48,scaleY:0.48,skewX:4.6,skewY:-174.4,x:477.7,y:83.5},0).wait(1).to({scaleX:0.48,scaleY:0.48,skewX:5,skewY:-174.5,x:477.6},0).wait(1).to({skewX:5.7,skewY:-174.3,x:477.5,y:83.6},0).to({_off:true},2).wait(40));

	// Lion Front Leg Back
	this.lion_frontlegback = new lib.LionFrontLegBack();
	this.lion_frontlegback.parent = this;
	this.lion_frontlegback.setTransform(397,78,0.483,0.483,0,5.7,-174.3,-2.6,-53.6);

	this.timeline.addTween(cjs.Tween.get(this.lion_frontlegback).wait(5).to({scaleX:0.48,scaleY:0.47,skewX:6.6,skewY:-174.7,x:397.9,y:79.9},0).wait(1).to({regY:-53.8,scaleY:0.46,skewX:7.7,skewY:-174.8,x:398.9,y:81.8},0).wait(1).to({regX:-2.5,scaleX:0.48,scaleY:0.47,skewX:8.3,skewY:-174.7,x:399.8,y:79.9},0).wait(1).to({regX:-2.6,regY:-53.7,scaleY:0.49,skewX:9,skewY:-174.2,x:400.8,y:78},0).wait(17).to({regX:-2.5,regY:-53.8,scaleY:0.47,skewX:8.3,skewY:-174.7,x:399.8,y:79.9},0).wait(1).to({regX:-2.6,scaleX:0.48,scaleY:0.46,skewX:7.7,skewY:-174.8,x:398.9,y:81.8},0).wait(1).to({regY:-53.6,scaleY:0.47,skewX:6.6,skewY:-174.7,x:397.9,y:79.9},0).wait(1).to({scaleX:0.48,scaleY:0.48,skewX:5.7,skewY:-174.3,x:397,y:78},0).wait(33).to({scaleX:0.48,scaleY:0.47,skewX:6.6,skewY:-174.7,x:397.9,y:79.9},0).wait(1).to({regY:-53.8,scaleY:0.46,skewX:7.7,skewY:-174.8,x:398.9,y:81.8},0).wait(1).to({regX:-2.5,scaleX:0.48,scaleY:0.47,skewX:8.3,skewY:-174.7,x:399.8,y:79.9},0).wait(1).to({regX:-2.6,regY:-53.7,scaleY:0.49,skewX:9,skewY:-174.2,x:400.8,y:78},0).wait(22).to({regX:-2.5,regY:-53.8,scaleY:0.47,skewX:8.3,skewY:-174.7,x:399.8,y:79.9},0).wait(1).to({regX:-2.6,scaleX:0.48,scaleY:0.46,skewX:7.7,skewY:-174.8,x:398.9,y:81.8},0).wait(1).to({regY:-53.6,scaleY:0.47,skewX:6.6,skewY:-174.7,x:397.9,y:79.9},0).wait(1).to({scaleX:0.48,scaleY:0.48,skewX:5.7,skewY:-174.3,x:397,y:78},0).wait(66).to({regX:-2.4,regY:-53.4,scaleX:0.48,scaleY:0.49,skewX:7.3,skewY:-174.4,x:398.8,y:78.1},0).wait(1).to({regX:-2.6,regY:-53.7,scaleX:0.49,scaleY:0.49,skewX:3.8,x:394.5,y:78},0).wait(1).to({regY:-53.6,scaleX:0.49,scaleY:0.48,skewX:0.3,skewY:-174.5,x:390.1},0).wait(1).to({scaleX:0.49,scaleY:0.48,skewX:-3.2,skewY:-174.4,x:385.7},0).wait(21).to({scaleX:0.49,scaleY:0.48,skewX:0.3,skewY:-174.5,x:390.1},0).wait(2).to({regY:-53.7,scaleX:0.49,scaleY:0.49,skewX:3.8,skewY:-174.4,x:394.5},0).wait(1).to({regX:-2.4,regY:-53.4,scaleX:0.48,scaleY:0.49,skewX:7.3,x:398.8,y:78.1},0).wait(1).to({regY:-53.6,scaleY:0.49,skewX:6.5,skewY:-174.5,x:397.9,y:78},0).wait(1).to({regX:-2.6,scaleX:0.48,scaleY:0.48,skewX:5.7,skewY:-174.3,x:397},0).wait(31).to({regX:-2.4,regY:-53.4,scaleX:0.48,scaleY:0.49,skewX:7.3,skewY:-174.4,x:398.8,y:78.1},0).wait(1).to({regX:-2.6,regY:-53.7,scaleX:0.49,scaleY:0.49,skewX:3.8,x:394.5,y:78},0).wait(1).to({regY:-53.6,scaleX:0.49,scaleY:0.48,skewX:0.3,skewY:-174.5,x:390.1},0).wait(1).to({scaleX:0.49,scaleY:0.48,skewX:-3.2,skewY:-174.4,x:385.7},0).wait(16).to({scaleX:0.49,scaleY:0.48,skewX:0.3,skewY:-174.5,x:390.1},0).wait(2).to({regY:-53.7,scaleX:0.49,scaleY:0.49,skewX:3.8,skewY:-174.4,x:394.5},0).wait(1).to({regX:-2.4,regY:-53.4,scaleX:0.48,scaleY:0.49,skewX:7.3,x:398.8,y:78.1},0).wait(1).to({regY:-53.6,scaleY:0.49,skewX:6.5,skewY:-174.5,x:397.9,y:78},0).wait(1).to({regX:-2.6,scaleX:0.48,scaleY:0.48,skewX:5.7,skewY:-174.3,x:397},0).to({_off:true},2).wait(40));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(342.6,18.3,180.4,137.4);


(lib.lion = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// mouthGlow
	this.mouthGlow = new lib.lion_mouthGlow();
	this.mouthGlow.parent = this;
	this.mouthGlow.setTransform(100.7,114.2,1,1,0,0,0,16.3,16.4);
	this.mouthGlow.alpha = 0;
	this.mouthGlow.filters = [new cjs.BlurFilter(4, 4, 1)];
	this.mouthGlow.cache(-5,-5,50,43);

	this.timeline.addTween(cjs.Tween.get(this.mouthGlow).wait(1));

	// legGlow
	this.legGlow = new lib.lion_legGlow();
	this.legGlow.parent = this;
	this.legGlow.setTransform(310,182.6,1,1,0,0,0,29.5,64.3);
	this.legGlow.alpha = 0;
	this.legGlow.filters = [new cjs.BlurFilter(4, 4, 1)];
	this.legGlow.cache(-159,-3,223,139);

	this.timeline.addTween(cjs.Tween.get(this.legGlow).wait(1));

	// maneGlow
	this.maneGlow = new lib.lion_maneGlow();
	this.maneGlow.parent = this;
	this.maneGlow.setTransform(145.7,118.5,1,1,0,0,0,50.5,66.4);
	this.maneGlow.alpha = 0;
	this.maneGlow.filters = [new cjs.BlurFilter(4, 4, 1)];
	this.maneGlow.cache(0,-5,106,143);

	this.timeline.addTween(cjs.Tween.get(this.maneGlow).wait(1));

	// pawGlow
	this.pawGlow = new lib.lion_footGlow();
	this.pawGlow.parent = this;
	this.pawGlow.setTransform(148.4,228.9,1,1,0,0,0,22.1,20.1);
	this.pawGlow.alpha = 0;
	this.pawGlow.filters = [new cjs.BlurFilter(4, 4, 1)];
	this.pawGlow.cache(-4,11,213,34);

	this.timeline.addTween(cjs.Tween.get(this.pawGlow).wait(1));

	// backGlow
	this.backGlow = new lib.lion_backGlow();
	this.backGlow.parent = this;
	this.backGlow.setTransform(232.8,137.9,1,1,0,0,0,87.9,30.2);
	this.backGlow.alpha = 0;
	this.backGlow.filters = [new cjs.BlurFilter(4, 4, 1)];
	this.backGlow.cache(45,-9,131,47);

	this.timeline.addTween(cjs.Tween.get(this.backGlow).wait(1));

	// Layer 39
	this.leg2 = new lib.invisiblebox();
	this.leg2.parent = this;
	this.leg2.setTransform(310.8,167,1.964,1.034,0,87,91.6);

	this.leg1 = new lib.invisiblebox();
	this.leg1.parent = this;
	this.leg1.setTransform(162.6,199.9,0.822,1.02,87);

	this.tummy = new lib.invisiblebox();
	this.tummy.parent = this;
	this.tummy.setTransform(233.6,180,0.869,2.163,87);

	this.back = new lib.invisiblebox();
	this.back.parent = this;
	this.back.setTransform(237.8,128.8,1.118,2.295,92.6);

	this.tail = new lib.invisiblebox();
	this.tail.parent = this;
	this.tail.setTransform(341.5,177.8,1.455,0.346,86.5);

	this.mane = new lib.invisiblebox();
	this.mane.parent = this;
	this.mane.setTransform(153.1,112.8,2.907,1.29,98.6);

	this.mouth = new lib.invisiblebox();
	this.mouth.parent = this;
	this.mouth.setTransform(99,113.7,1.107,0.964,0,89.1,96.8);

	this.paw2 = new lib.invisiblebox();
	this.paw2.parent = this;
	this.paw2.setTransform(316,235.4,1.199,0.78,3.5);

	this.paw1 = new lib.invisiblebox();
	this.paw1.parent = this;
	this.paw1.setTransform(147.4,239.8,1.178,0.599,0,-2.3,-2.8);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.paw1},{t:this.paw2},{t:this.mouth},{t:this.mane},{t:this.tail},{t:this.back},{t:this.tummy},{t:this.leg1},{t:this.leg2}]}).wait(1));

	// main
	this.main = new lib.Lion();
	this.main.parent = this;
	this.main.setTransform(-471.7,150.3,1.668,1.668,-4.2,0,0,22.4,55.4);

	this.timeline.addTween(cjs.Tween.get(this.main).wait(1));

}).prototype = getMCSymbolPrototype(lib.lion, new cjs.Rectangle(67.2,47.1,297,212.5), null);


// stage content:
(lib.MWlion = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = null;
// library properties:
lib.properties = {
	width: 600,
	height: 307,
	fps: 30,
	color: "#FFFFFF",
	opacity: 1.00,
	manifest: [
		{src:"../../../deploy/assets/images/MWlion_atlas_.png?1528491507780", id:"MWlion_atlas_"}
	],
	preloads: []
};




})(lib_Lion = lib_Lion||{}, images = images||{}, createjs = createjs||{}, ss = ss||{}, AdobeAn = AdobeAn||{});
var lib_Lion, images, createjs, ss, AdobeAn;